import React, { useState, useEffect, useRef, Fragment, useCallback} from 'react';
import { TransformWrapper, TransformComponent} from "react-zoom-pan-pinch";
import axios from 'axios';
import './App.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import 'react-phone-number-input/style.css';
import 'swiper/css';
import 'swiper/css/navigation';

import ContextMenu from './components/ContextMenu';
import { Room } from 'livekit-client';
import CallModal from './components/modals/CallModal';
import Auth from './components/Auth';
import ContextMenuModal from './components/ContextMenuModal';
import { requestFirebaseToken, onFirebaseMessage } from './firebase';
import api, { setTokenUpdateCallback, setAccessToken, setTokens, clearTokens } from './Api';
import FileAttachment from './components/media/FileAttachment';
import ConnectionStatus from './components/ConnectionStatus';
import WebSocketStatus from './components/WebSocketStatus';

import { AudioPlayerProvider } from './contexts/AudioPlayerContext';
import {clearFileCache} from './hooks/useFileLoader'
import { useTyping } from './hooks/useTyping';
import { 
    API_URL, 
    WS_URL, 
    LIVEKIT_URL,   
    MAX_FILES_COUNT,
    MAX_RECORDING_TIME,   
    IS_IOS,
    IS_STANDALONE,
    IS_IOS_WITHOUT_PWA,
    SUPPORTS_PUSH, 
    TIMEOUT_UPLOAD,
} from './utils/constants';

import {    
    formatDateHeader,        
    formatDuration,
} from './utils/formatters';

import {    
    getUserColor,
    cleanUser,   
} from './utils/userHelpers';

import { extractUrls } from './utils/fileHelpers';
import Toast from './components/common/Toast';
import ConfirmModal from './components/modals/ConfirmModal';
import ProfileModal from './components/modals/ProfileModal';
import ForwardModal from './components/modals/ForwardModal';
import CreateGroupModal from './components/modals/CreateGroupModal';
import EditGroupModal from './components/modals/EditGroupModal';
import InviteModal from './components/modals/InviteModal';
import Message from './components/chat/Message';
import ChatHeader from './components/chat/ChatHeader';
import ChatList from './components/chat/ChatList';
import ReplyIndicator from './components/chat/ReplyIndicator';
import EditIndicator from './components/chat/EditIndicator';
import AttachmentsPreview from './components/chat/AttachmentsPreview';
import UploadProgress from './components/chat/UploadProgress';
import MessageInput from './components/chat/MessageInput';


function App() {
  const [token, setToken] = useState(localStorage.getItem('access_token') || '');
  const [user, setUser] = useState(null);
  const [chats, setChats] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [currentChat, setCurrentChat] = useState(null);
  const [messages, setMessages] = useState([]);
  const [inputMessage, setInputMessage] = useState('');
  const [replyTo, setReplyTo] = useState(null);
  const [replyToMessage, setReplyToMessage] = useState(null); 
  const [loading, setLoading] = useState(false);

  const [editingMessage, setEditingMessage] = useState(null);

  
  // ========== ДОБАВЬ ЭТИ СТРОКИ ==========
  const [showNewChat, setShowNewChat] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const [searchResults, setSearchResults] = useState([]);
  const [searching, setSearching] = useState(false);
  // ========== КОНТЕКСТНОЕ МЕНЮ ==========
 
  const [contextMenu, setContextMenu] = useState(null);  
  const [contextMenuModal, setContextMenuModal] = useState(null);
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
  const [messageToDelete, setMessageToDelete] = useState(null); 

  const [showProfileModal, setShowProfileModal] = useState(false);
  const [showForwardModal, setShowForwardModal] = useState(false);
  const [forwardMessage, setForwardMessage] = useState(null);

  const [attachments, setAttachments] = useState([]);


  const [isDragging, setIsDragging] = useState(false); 
  

  const [firstUnreadIndex, setFirstUnreadIndex] = useState(-1);

  const [galleryOpen, setGalleryOpen] = useState(false);
  const [galleryImages, setGalleryImages] = useState([]);
  const [galleryIndex, setGalleryIndex] = useState(0);

  const [hasMore, setHasMore] = useState(true);
  const [isLoadingMore, setIsLoadingMore] = useState(false);
  const skipAutoScroll = useRef(false);
  const [showScrollButton, setShowScrollButton] = useState(false);

  // Группы
  const [showCreateGroup, setShowCreateGroup] = useState(false);
  const [showEditGroupModal, setShowEditGroupModal] = useState(false);
  const [editingGroup, setEditingGroup] = useState(null);
  const [showInviteModal, setShowInviteModal] = useState(false);
  const [inviteGroup, setInviteGroup] = useState(null);


  const [notification, setNotification] = useState({ show: false, message: '', type: 'info' });
  const [confirmModal, setConfirmModal] = useState({ show: false, title: '', message: '', onConfirm: null, danger: false });

  const [mobileMenuOpen, setMobileMenuOpen] = useState(true);

const [isRecording, setIsRecording] = useState(false);
const [mediaRecorder, setMediaRecorder] = useState(null);
const [audioChunks, setAudioChunks] = useState([]);
const [recordingTime, setRecordingTime] = useState(0);

const [activePlayerId, setActivePlayerId] = useState(null);
//Стикеры
const [showStickerPicker, setShowStickerPicker] = useState(false);

const [notificationPermission, setNotificationPermission] = useState(
    typeof Notification !== 'undefined' ? Notification.permission : 'default'
);
const [notificationsEnabled, setNotificationsEnabled] = useState(() => {    
    const saved = localStorage.getItem('notifications_enabled');
    return saved !== 'false'; 
});
const [wsConnected, setWsConnected] = useState(false);
const [wsReconnecting, setWsReconnecting] = useState(false);
const [wsError, setWsError] = useState(null);
const [wsLastCloseCode, setWsLastCloseCode] = useState(null); 
const [isAppActive, setIsAppActive] = useState(true);

const [incomingCall, setIncomingCall] = useState(null);


const [activeCall, setActiveCall] = useState(null);

const isAppActiveRef = useRef(isAppActive);
const textareaRef = useRef(null);
const wsRef = useRef(null);
const reconnectTimerRef = useRef(null);

const reconnectAttemptsRef = useRef(0);
const isIntentionalCloseRef = useRef(false);
const messagesEndRef = useRef(null);
const messagesContainerRef = useRef(null);
const currentChatIdRef = useRef(null);
const recordingTimerRef = useRef(null);
const currentChatRef = useRef(currentChat);
const isConnectingRef = useRef(false);
const mountRef = useRef(true);
const sendPendingMessagesRef = useRef(null);
const handleWebSocketMessageRef = useRef(null);
const connectWebSocketRef = useRef(null);
const loadChatsRef = useRef(null);
const loadUserProfileRef = useRef(null);
const loadMessagesRef = useRef(null);
const loadAllDataRef = useRef(null);
const audioContext = useRef(null);

const [uploadProgress, setUploadProgress] = useState(0);
const [isUploading, setIsUploading] = useState(false);
const { handleTyping, resetTyping } = useTyping(wsRef, currentChat);
const [typingMessage, setTypingMessage] = useState(null); // { chat_id, user_id, display_name }
const [showMembersList, setShowMembersList] = useState(false);
const dataLoadedRef = useRef(false);
const isFirstLoadRef = useRef(true);
const pingIntervalRef = useRef(null);
const userRef = useRef(user);
const connectionTimeoutRef = useRef(null);
const pongTimeoutRef = useRef(null);
const markReadTimerRef = useRef(null);
const shouldAutoScrollRef = useRef(true);
const lastMarkedReadRef = useRef({});
const selectChatRef = useRef(null);
const chatsRef = useRef(chats);
const onFirebaseMessageHandlerRef = useRef(null);
const swRegistrationRef = useRef(null);
const ringtoneIntervalRef = useRef(null);

 // ✅ Регистрируем колбэк для синхронизации
useEffect(() => {
    setTokenUpdateCallback((newToken) => {
        setToken(newToken || '');
    });
    return () => setTokenUpdateCallback(null);
}, []);
useEffect(() => {
    userRef.current = user;
}, [user]);
// Функция для обработки выбора стикера
 const handleStickerSelect = (sticker) => {
         // Отправляем как сообщение со стикером
        sendStickerMessage({
            type: 'sticker',
            content: {
                id: sticker.id,
                url: sticker.url,
                emoji: sticker.emoji,
                file_type: sticker.file_type
            }
        });
        setShowStickerPicker(false);
    };
const handleAuthSuccess = (access_token, refresh_token, user) => {
   
    setAccessToken(access_token);
    localStorage.setItem('refresh_token', refresh_token);   
    setToken(access_token);
    setTokens(access_token,refresh_token);
    setUser(cleanUser(user));
    isConnectingRef.current = false; // ← Сбрасываем!
    reconnectAttemptsRef.current = 0; // ← Сбрасываем!
    resetWsStatus();
    dataLoadedRef.current = false;

    //loadChats();   
    
    requestFirebaseToken().then(firebaseToken => {
        if (firebaseToken) {
            api.post('/push/register', { token: firebaseToken });
        }
    }).catch(error => {
        console.error('Push registration failed:', error);
    });
}; 
// ✅ 1. Включить уведомления (запрашивает permission, если нужно, регистрирует токен)
const enableNotifications = useCallback(async () => {
    // Проверка поддержки
    if (!SUPPORTS_PUSH) {
        showNotification('Уведомления не поддерживаются в браузере', 'error');
        return;
    }

    // iOS без PWA
    if (IS_IOS_WITHOUT_PWA) {
        showNotification('Сначала установите приложение на экран «Домой»', 'warning');
        return;
    }
    const realPermission = Notification.permission;
    setNotificationPermission(realPermission); // обновляем React

    // Разрешение заблокировано — не можем запросить
    if (realPermission === 'denied') {
        showNotification(
            'Разрешите уведомления в настройках браузера (замок 🔒 в адресной строке)',
            'error'
        );
        return;
    }

    // Запрашиваем permission только если default
    if (realPermission === 'default') {
        try {
            const permission = await Notification.requestPermission();
            setNotificationPermission(permission);

            if (permission !== 'granted') {
                showNotification('Разрешение не получено', 'warning');
                return;
            }
        } catch (error) {
            console.error('Permission request failed:', error);
            showNotification('Не удалось запросить разрешение', 'error');
            return;
        }
    }
    // localStorage.removeItem('firebase_token_registered_at');

    // Permission есть — включаем app-toggle
    setNotificationsEnabled(true);
    localStorage.setItem('notifications_enabled', 'true');   
    localStorage.removeItem('firebase_token_registered_at');
     try {
        const token = await requestFirebaseToken();
        if (token) {
            await api.post('/push/register', { token });
            localStorage.setItem('firebase_token', token);
            localStorage.setItem('firebase_token_registered_at', new Date().toISOString());
            console.log('✅ Push enabled');
        }
    } catch (e) { console.error(e); }
 
    showNotification('Уведомления включены', 'success');
}, []);
// ✅ 2. Отключить уведомления (только app-toggle, permission не трогаем)
const disableNotifications = useCallback(async () => {
    setNotificationsEnabled(false);
    localStorage.setItem('notifications_enabled', 'false');
    localStorage.removeItem('firebase_token_registered_at');
    localStorage.removeItem('firebase_token');
    
    // Сообщаем серверу, чтобы не отправлял push
    try {
        await api.post('/push/unregister');
        console.log('✅ Push disabled, unregistered on server');
    } catch (e) {
        console.error('Push unregister failed:', e);
    }

    showNotification('Уведомления отключены', 'info');
}, []);
const showSystemNotification = useCallback(async (title, options) => {
    if (Notification.permission !== 'granted') {
        console.warn('⚠️ Нет разрешения на уведомления');
        return;
    }

    try {
        // ✅ Используем кэш, или ждём готовности
        const registration = swRegistrationRef.current 
            || await navigator.serviceWorker.ready;
        
        await registration.showNotification(title, options);
        console.log('✅ showNotification via SW:', title);
    } catch (e) {
        console.warn('⚠️ SW showNotification failed, fallback:', e);
        // Fallback для старых браузеров
        try {
            new Notification(title, options);
            console.log('✅ showNotification via Notification constructor');
        } catch (e2) {
            console.warn('⚠️ Notification constructor also failed:', e2);
        }
    }
}, []);
const playRingtone = () => {
    try {
        const ctx = audioContext.current;
        if (!ctx) return;
        
        if (ctx.state === 'suspended') ctx.resume();
        
        const now = ctx.currentTime;
        
        // Более реалистичный рингтон: две ноты с вибрацией
        const playNote = (startTime, freq, duration, volume = 0.25) => {
            const osc = ctx.createOscillator();
            const gain = ctx.createGain();
            
            osc.type = 'triangle'; // мягче, чем sine
            osc.frequency.value = freq;
            
            osc.connect(gain);
            gain.connect(ctx.destination);
            
            gain.gain.setValueAtTime(0, startTime);
            gain.gain.linearRampToValueAtTime(volume, startTime + 0.02);
            gain.gain.setValueAtTime(volume, startTime + duration - 0.02);
            gain.gain.linearRampToValueAtTime(0, startTime + duration);
            
            osc.start(startTime);
            osc.stop(startTime + duration);
        };
        
        // Классический рингтон: "дринь-дринь"
        playNote(now, 1200, 0.1);
        playNote(now + 0.15, 1600, 0.1);
        playNote(now + 0.3, 1200, 0.1);
        playNote(now + 0.45, 1600, 0.1);
        
    } catch (e) {
        console.error('Ringtone error:', e);
    }
};
const playNotificationSoundOne = () => {
    try {
        // Простой звук через Web Audio
        const ctx = audioContext.current;
        if (!ctx) return;
        
         const notes = [880, 1047];
        notes.forEach((freq, i) => {
            const oscillator = ctx.createOscillator();
            const gainNode = ctx.createGain();
            oscillator.connect(gainNode);
            gainNode.connect(ctx.destination);
            oscillator.frequency.value = freq;
            oscillator.type = 'sine';
            const startTime = ctx.currentTime + i * 0.12;
            gainNode.gain.setValueAtTime(0.15, startTime);
            gainNode.gain.exponentialRampToValueAtTime(0.01, startTime + 0.15);
            oscillator.start(startTime);
            oscillator.stop(startTime + 0.15);
        });
    } catch (error) {
        // Если звук не работает — игнорируем
    }
};
const playNotificationSoundTwo = () => {
    try {
        const ctx = audioContext.current;
        if (!ctx) return;
        
        // Возобновляем контекст (браузеры блокируют до первого взаимодействия)
        if (ctx.state === 'suspended') {
            ctx.resume();
        }
        
        const playKnock = (startTime, pitch = 120) => {
            // Основной удар — короткий шум + низкий тон
            const osc = ctx.createOscillator();
            const gain = ctx.createGain();
            const filter = ctx.createBiquadFilter();
            
            osc.type = 'sine';
            osc.frequency.setValueAtTime(pitch, startTime);
            osc.frequency.exponentialRampToValueAtTime(pitch * 0.5, startTime + 0.08);
            
            filter.type = 'lowpass';
            filter.frequency.value = 800;
            
            osc.connect(filter);
            filter.connect(gain);
            gain.connect(ctx.destination);
            
            gain.gain.setValueAtTime(0, startTime);
            gain.gain.linearRampToValueAtTime(0.4, startTime + 0.005);
            gain.gain.exponentialRampToValueAtTime(0.001, startTime + 0.12);
            
            osc.start(startTime);
            osc.stop(startTime + 0.15);
        };
        
        const now = ctx.currentTime;
        playKnock(now, 140);        // первый тук
        playKnock(now + 0.15, 120); // второй тук (чуть ниже)
        
    } catch (error) {
        // игнорируем
    }
};
const playNotificationSoundThree = () => {
    try {
        const ctx = audioContext.current;
        if (!ctx) return;
        
        if (ctx.state === 'suspended') {
            ctx.resume();
        }
        
        const now = ctx.currentTime;
        
        // Низкий удар (бум)
        const osc = ctx.createOscillator();
        const gain = ctx.createGain();
        osc.type = 'sine';
        osc.frequency.setValueAtTime(80, now);
        osc.frequency.exponentialRampToValueAtTime(40, now + 0.15);
        
        osc.connect(gain);
        gain.connect(ctx.destination);
        gain.gain.setValueAtTime(0.5, now);
        gain.gain.exponentialRampToValueAtTime(0.001, now + 0.2);
        
        osc.start(now);
        osc.stop(now + 0.25);
        
        // Резкий "щелчок" — высокочастотный шум через короткий буфер
        const bufferSize = ctx.sampleRate * 0.03; // 30мс
        const buffer = ctx.createBuffer(1, bufferSize, ctx.sampleRate);
        const data = buffer.getChannelData(0);
        for (let i = 0; i < bufferSize; i++) {
            // Затухающий шум
            data[i] = (Math.random() * 2 - 1) * (1 - i / bufferSize);
        }
        
        const noise = ctx.createBufferSource();
        noise.buffer = buffer;
        
        const noiseFilter = ctx.createBiquadFilter();
        noiseFilter.type = 'bandpass';
        noiseFilter.frequency.value = 2000;
        noiseFilter.Q.value = 1;
        
        const noiseGain = ctx.createGain();
        noiseGain.gain.setValueAtTime(0.3, now);
        noiseGain.gain.exponentialRampToValueAtTime(0.001, now + 0.05);
        
        noise.connect(noiseFilter);
        noiseFilter.connect(noiseGain);
        noiseGain.connect(ctx.destination);
        
        noise.start(now);
        noise.stop(now + 0.05);
        
    } catch (error) {
        // игнорируем
    }
};
const playNotificationSoundFour = () => {
    try {
        const ctx = audioContext.current;
        if (!ctx) return;
        
        if (ctx.state === 'suspended') {
            ctx.resume();
        }
        
        const now = ctx.currentTime;
        
        // Основной тон — быстро поднимается и затухает
        const osc = ctx.createOscillator();
        const gain = ctx.createGain();
        
        osc.type = 'sine';
        osc.frequency.setValueAtTime(400, now);
        osc.frequency.exponentialRampToValueAtTime(900, now + 0.05);
        osc.frequency.exponentialRampToValueAtTime(500, now + 0.15);
        
        osc.connect(gain);
        gain.connect(ctx.destination);
        
        gain.gain.setValueAtTime(0, now);
        gain.gain.linearRampToValueAtTime(0.35, now + 0.01);
        gain.gain.exponentialRampToValueAtTime(0.001, now + 0.2);
        
        osc.start(now);
        osc.stop(now + 0.25);
        
        // Добавляем легкий "всплеск" — шум с быстрым затуханием
        const bufferSize = ctx.sampleRate * 0.08;
        const buffer = ctx.createBuffer(1, bufferSize, ctx.sampleRate);
        const data = buffer.getChannelData(0);
        for (let i = 0; i < bufferSize; i++) {
            data[i] = (Math.random() * 2 - 1) * Math.pow(1 - i / bufferSize, 3);
        }
        
        const noise = ctx.createBufferSource();
        noise.buffer = buffer;
        
        const filter = ctx.createBiquadFilter();
        filter.type = 'highpass';
        filter.frequency.value = 1500;
        
        const noiseGain = ctx.createGain();
        noiseGain.gain.setValueAtTime(0.15, now);
        noiseGain.gain.exponentialRampToValueAtTime(0.001, now + 0.1);
        
        noise.connect(filter);
        filter.connect(noiseGain);
        noiseGain.connect(ctx.destination);
        
        noise.start(now);
        noise.stop(now + 0.1);
        
    } catch (error) {
        // игнорируем
    }
};
const playNotificationSoundFive = () => {
    try {
        const ctx = audioContext.current;
        if (!ctx) return;
        
        if (ctx.state === 'suspended') {
            ctx.resume();
        }
        
        const now = ctx.currentTime;
        
        // Основной плюх
        const playPlop = (startTime, volume = 0.4) => {
            const osc = ctx.createOscillator();
            const gain = ctx.createGain();
            
            osc.type = 'sine';
            osc.frequency.setValueAtTime(450, startTime);
            osc.frequency.exponentialRampToValueAtTime(1200, startTime + 0.03);
            osc.frequency.exponentialRampToValueAtTime(300, startTime + 0.18);
            
            osc.connect(gain);
            gain.connect(ctx.destination);
            
            gain.gain.setValueAtTime(0, startTime);
            gain.gain.linearRampToValueAtTime(volume, startTime + 0.008);
            gain.gain.exponentialRampToValueAtTime(0.001, startTime + 0.22);
            
            osc.start(startTime);
            osc.stop(startTime + 0.25);
        };
        
        // Основной звук
        playPlop(now, 0.4);
        // Лёгкое эхо
        playPlop(now + 0.08, 0.15);
        playPlop(now + 0.16, 0.06);
        
    } catch (error) {
        // игнорируем
    }
};
const playSentSound = () => {
    try {
        const ctx = audioContext.current;
        if (!ctx) return;
        
        if (ctx.state === 'suspended') {
            ctx.resume();
        }
        
        const now = ctx.currentTime;
        
        // ✅ Функция для одного "щелчка"
        // freq — центральная частота фильтра (выше = звонче)
        // volume — громкость
        // duration — длительность в секундах
        const playClick = (startTime, freq, volume, duration) => {
            // Создаём очень короткий буфер с шумом
            const bufferSize = Math.max(1, Math.floor(ctx.sampleRate * duration));
            const buffer = ctx.createBuffer(1, bufferSize, ctx.sampleRate);
            const data = buffer.getChannelData(0);
            
            // Заполняем шумом с экспоненциальным затуханием
            // Это даёт "природный" звук, а не чистый тон
            for (let i = 0; i < bufferSize; i++) {
                const t = i / bufferSize;
                // Затухание: быстро в начале, ещё быстрее в конце
                const envelope = Math.pow(1 - t, 3);
                // Немного модуляции для "металличности"
                const mod = 0.7 + 0.3 * Math.sin(i * 0.3);
                data[i] = (Math.random() * 2 - 1) * envelope * mod;
            }
            
            const noise = ctx.createBufferSource();
            noise.buffer = buffer;
            
            // Полосовой фильтр — выделяет "щелкающую" частоту
            const filter = ctx.createBiquadFilter();
            filter.type = 'bandpass';
            filter.frequency.value = freq;
            filter.Q.value = 2; // умеренная добротность
            
            // Ещё один фильтр — срезает лишний шум снизу
            const hpFilter = ctx.createBiquadFilter();
            hpFilter.type = 'highpass';
            hpFilter.frequency.value = freq * 0.6;
            
            const gain = ctx.createGain();
            gain.gain.setValueAtTime(volume, startTime);
            gain.gain.exponentialRampToValueAtTime(0.001, startTime + duration);
            
            noise.connect(filter);
            filter.connect(hpFilter);
            hpFilter.connect(gain);
            gain.connect(ctx.destination);
            
            noise.start(startTime);
            noise.stop(startTime + duration);
        };
        
        // ✅ Фаза 1: "Клик" — открытие затвора
        // Высокий, звонкий, очень короткий
        playClick(now, 3000, 0.35, 0.025);
        
        // ✅ Фаза 2: "Клак" — закрытие затвора  
        // Чуть ниже, глуше, через 40 мс
        playClick(now + 0.04, 1700, 0.20, 0.035);
        
    } catch (error) {
        // игнорируем
    }
};
// Запуск рингтона (циклично каждые 2 секунды)
const startRingtone = () => {
    stopRingtone(); // на всякий случай
    playRingtone();
    ringtoneIntervalRef.current = setInterval(playRingtone, 2000);
};

// Остановка рингтона
const stopRingtone = () => {
    if (ringtoneIntervalRef.current) {
        clearInterval(ringtoneIntervalRef.current);
        ringtoneIntervalRef.current = null;
    }
};
  // Функция для отображения уведомлений
  const showNotification = (message, type = 'info') => {
      setNotification({ show: true, message, type });
     
      // Автоматически скрываем через 3 секунды
      setTimeout(() => {
          setNotification({ show: false, message: '', type: 'info' });
      }, 3000);
  };
  // Функция для отображения модального окна подтверждения
  const showConfirm = (title, message, onConfirm, danger = false) => {
      setConfirmModal({ show: true, title, message, onConfirm, danger });
  };
  // Функция открытия галереи изображений
  const openGallery = (attachments, index) => {
    const imagesOnly = attachments.filter(a => a.file_type === 'image');
      setGalleryImages(imagesOnly);
      setGalleryIndex(index);
      setGalleryOpen(true);
  };


// Загрузка списка чатов
const loadChats = useCallback(async (options = {}) => {
    const { loadMessages: loadMessagesFlag = false } = options;
    const currentToken = localStorage.getItem('access_token');
    if (!currentToken || !navigator.onLine) {
        return;
    }    
    setIsLoading(true);
    try {
        const response = await api.get('/chats');       
        setChats(response.data);
         if (loadMessagesFlag && currentChatRef.current && typeof loadMessagesRef.current === 'function') {
            console.log('💬 Loading messages for current chat...');
            await loadMessagesRef.current(currentChatRef.current.chat_id);
        }
        return response.data;
    } catch (error) {
        // ✅ ТОЛЬКО ЛОГ! Никакой логики очистки/редиректа!
        console.error('Failed to load chats:', error.message);
        throw error;
    } finally {
        setIsLoading(false);
    }
}, []);  
    // ✅ Универсальная функция обновления чата
const updateChat = useCallback((chatId, updates,  moveToTop = true) => {    
    setChats(prev => {
        const chatIndex = prev.findIndex(chat => chat.chat_id === chatId); 
        
        if (chatIndex === -1) return prev;        
        const oldChat = prev[chatIndex];        
        // Обрабатываем функциональные обновления
        let processedUpdates = {};
        for (const [key, value] of Object.entries(updates)) {
            if (typeof value === 'function') {
                processedUpdates[key] = value(oldChat[key]);
            } else {
                processedUpdates[key] = value;
            }
        }        
        const updatedChat = {
            ...oldChat,
            ...processedUpdates,
              last_message_status: processedUpdates.last_message_status || oldChat.last_message_status,
            last_message_time: processedUpdates.last_message?.timestamp || oldChat.last_message_time
        };        
        // Поднимаем вверх
        const newChats = [...prev];
        if (!moveToTop) {
            newChats[chatIndex] = updatedChat;
            return newChats;
        }
        newChats.splice(chatIndex, 1);
        return [updatedChat, ...newChats];
    });
}, []); 
// Обработка входящих WebSocket сообщений (НОВАЯ версия)
const handleWebSocketMessage = useCallback(async (data) => {
    const currentChat = currentChatRef.current;
    
    if (data.type === 'message_deleted') {
    // ✅ Сначала обновляем messages
    setMessages(prev => {
        let newMessages;        
        if (data.is_permanent) {
            // Полное удаление
            newMessages = prev.filter(m => m.id !== data.message_id);
        } else {
            // Временное удаление (показываем "Сообщение удалено")
            newMessages = prev.map(m => 
                m.id === data.message_id 
                    ? { ...m, content: 'Сообщение удалено', is_deleted: true }
                    : m
            );
        }
        
        // ✅ Затем обновляем chats с использованием newMessages
        setChats(prevChats => {
            return prevChats.map(chat => {
                if (chat.chat_id !== data.chat_id) return chat;
                if (!chat.last_message) return chat;
                
                // Если удалено НЕ последнее — ничего не делаем
                if (chat.last_message.id !== data.message_id) return chat;
                
                // Если удалено последнее — находим новое последнее
                const remainingMessages = newMessages.filter(m => 
                    m.chat_id === data.chat_id && 
                    m.id !== data.message_id
                );
                
                if (remainingMessages.length === 0) {
                    // Сообщений больше нет
                    return {
                        ...chat,
                        last_message: {
                            content: 'Нет сообщений',
                            id: 0,
                            from_id: 0,
                            created_at: new Date().toISOString(),
                            is_deleted: true
                        }
                    };
                }
                
                // Находим новое последнее сообщение
                const newLast = remainingMessages.reduce((a, b) => a.id > b.id ? a : b);
                return {
                    ...chat,
                    last_message: newLast
                };
            });
        });
        
        return newMessages;
    });
    
    return;
    // 2. Новая группа или добавление в группу  
    } else if (data.type === 'new_group' || data.type === 'added_to_group') {
        // ✅ Добавляем новый чат в список (без перезагрузки)
        setChats(prev => [{
            chat_id: data.chat_id,
            title: data.title,
            avatar: data.avatar,
            is_group: true,
            last_message: data.last_message || null,
            unread_count: 0,
            participants: data.participants || []
        }, ...prev]);
        return;
    // 3. Удаление группы  
    } else if (data.type === 'group_deleted') {
        setChats(prev => prev.filter(chat => chat.chat_id !== data.chat_id));
        if (currentChat?.chat_id === data.chat_id) {
            setCurrentChat(null);
            setMessages([]);
        }
        return;
    // 4. Приглашение в группу
    } else if (data.type === 'group_invite') {
        showConfirm(
            'Приглашение в группу',
            `${data.inviter_name} пригласил(а) вас в группу "${data.group_title}"`,
            async () => {
                await api.post(`/groups/${data.group_id}/join`);
                // ✅ После присоединения - добавляем чат в список
                const response = await api.get(`/chats/${data.group_id}`);
                setChats(prev => [response.data, ...prev]);
                showNotification('Вы присоединились к группе', 'success');
            },
            false,
            'Принять',
            'Отклонить'
        );
        return;
    } else if (data.type === 'typing') {
        updateChat(data.chat_id, {
            is_typing: data.is_typing,
            typing_user_id: data.user_id,
            display_name: data.display_name
        }, false);
        
        if (currentChat && currentChat.chat_id === data.chat_id) {
            if (data.is_typing) {
            // Показываем "печатает..."
            setTypingMessage({
                chat_id: data.chat_id,
                user_id: data.user_id,
                display_name: data.display_name || 'Собеседник'
            });
        } else {
            // Скрываем
            setTypingMessage(null);
        }
            setCurrentChat(prev => ({ 
                ...prev, 
                is_typing: data.is_typing,
                typing_user_id: data.user_id
            }));
        }
        return;
     // 5. Статус пользователя (онлайн/офлайн)
    } else if (data.type === 'user_status') {
      
        // ✅ Обновляем статус пользователя      
        updateChat(data.chat_id, {
            is_online: data.is_online,
            last_seen: data.last_seen
        }, false);
        if (currentChat && currentChat.chat_id === data.chat_id) {
            setCurrentChat(prev => ({ ...prev, is_online: data.is_online, last_seen: data.last_seen }));
        }
        return;       
    } else if (data.type === 'message_read') {
    // ✅ Обновляем статус в списке сообщений (если чат открыт)
    if (currentChat && currentChat.chat_id === data.chat_id) {
        setMessages(prev => prev.map(msg =>{
            if (msg.is_outgoing && msg.id <= data.message_id) {
                return { ...msg, read_at: data.read_at, status: 'read' };
            }
            return msg;
        }));
    }
    
    // ✅ Обновляем статус в списке чатов (если это последнее сообщение)
    setChats(prev => prev.map(chat => {
        if (chat.chat_id !== data.chat_id) return chat;
        if (!chat.last_message || chat.last_message.id !== data.message_id) return chat;
        if (chat.last_message.from_id !== user?.id) return chat; // только свои
        
        return {
            ...chat,
            last_message: {
                ...chat.last_message,
                read_at: data.read_at,
                status: 'read'
            }
        };
    }));
    return;
    } else if (data.type === 'message_delivered') {
    
    if (currentChat && currentChat.chat_id === data.chat_id) {
        setMessages(prev => prev.map(msg =>{
            if (msg.is_outgoing && msg.id <= data.message_id && msg.status !== 'read' && msg.status !== 'delivered') {
                return { ...msg, delivered_at: data.delivered_at, status: 'delivered' };
            }
            return msg;
        }));
    }    
    setChats(prev => prev.map(chat => {
        if (chat.chat_id !== data.chat_id) return chat;
        if (!chat.last_message || chat.last_message.id !== data.message_id) return chat;
        if (chat.last_message.from_id !== user?.id) return chat;
        
        return {
            ...chat,
            last_message: {
                ...chat.last_message,
                delivered_at: data.delivered_at,
                status: 'delivered'
            }
        };
    }));
    return;
    } else if (data.type === 'auth_warning' && data.reason === 'token_expiring_soon') {
    console.log('⏳ Token expiring soon, refreshing...');
    // ✅ Обновляем токен через HTTP
    const refreshToken = localStorage.getItem('refresh_token');
    if (refreshToken) {
        try {
            const response = await axios.post(`${API_URL}/auth/refresh`, {
                refresh_token: refreshToken
            });
            const { access_token, refresh_token } = response.data;
            
            // ✅ Сохраняем и отправляем через WebSocket
            setTokens(access_token, refresh_token);
            
        } catch (error) {
            console.error('Failed to refresh token:', error);
        }
    }
    return;
    } else if (data.type === 'message_edited') {
    setMessages(prev => prev.map(msg => 
        msg.id === data.message_id
            ? { ...msg, content: data.content, edited_at: data.edited_at }
            : msg
    ));
    } else if (data.type === 'call') {
        if (data.from_user_id === user?.id) return; // игнорируем свои
        
        if (data.action === 'offer') {
            // Показываем входящий звонок
            setIncomingCall({
                chatId: data.chat_id,
                fromUserId: data.from_user_id,
                fromName: data.from_name,
                room: data.room,
                isVideo: data.is_video
            });
            startRingtone();
        } else if (data.action === 'accept') {
            console.log('Call accepted by other user');
            stopRingtone();
        } else if (data.action === 'reject') {
            stopRingtone();
            endCall(false);            
            showNotification('Звонок отклонён', 'info');
        } else if (data.action === 'end') {
            stopRingtone();   
            console.log('Received end call from other user');
           if (incomingCall) setIncomingCall(null);
            endCall(false);
        }
    } else if (data.id) {
        if (data.is_forwarded) {
            // ✅ ТОЛЬКО обновляем last_message в списке чатов
            updateChat(data.chat_id, {
                last_message: {
                    ...data,
                    is_outgoing: data.from_id === user?.id,
                    status: data.from_id === user?.id ? 'sent' : null,
                    is_forwarded: true,
                    content: data.forward_message.content || 'Пересланное сообщение',
                }
                
            });
            
            // Если это чужое пересланное сообщение — увеличиваем счетчик
            if (data.from_id !== user?.id && (!currentChat || data.chat_id !== currentChat.chat_id)) {
                playNotificationSoundOne();
                updateChat(data.chat_id, {
                    unread_count: (prev) => (prev || 0) + 1
                });
            }          
            
            return;
        }
         // Если это наше сообщение (эхо от сервера)
    if (data.from_id === user?.id) {
        // ✅ Добавляем сообщение в список (если еще нет)
        setMessages(prev => {
            // Проверяем, есть ли уже такое сообщение
            const exists = prev.some(msg => msg.id === data.id );
            if (exists) return prev;
            
            // Добавляем новое сообщение
            return [...prev, {
                ...data,
                status: 'sent',
                is_outgoing: true,
                delivered_at: data.delivered_at || null,
                read_at: data.read_at || null,
                link_previews: data.link_previews || []
            }];
        });
        playSentSound();
        // Обновляем последнее сообщение в списке чатов
        updateChat(data.chat_id, {
            last_message: {
                ...data,
                status: 'sent',
                is_outgoing: true,
                delivered_at: data.delivered_at || null,
                read_at: data.read_at || null
            }
       
        });              
        return; // ← ВАЖНО: не добавляем новое сообщение!
    }

        // ✅ Если это не текущий чат - обновляем счетчик и последнее сообщение
        if (!currentChat || data.chat_id !== currentChat.chat_id) {
            if (data.from_id !== user?.id) {
                playNotificationSoundFive();               
                updateChat(data.chat_id, {
                    unread_count: (prev) => (prev || 0) + 1,
                    last_message: data
                   
                });
            }else {
                // ✅ Если это наше сообщение (эхо) — обновляем статус на "sent"
                updateChat(data.chat_id, {
                    last_message: data
                });
            }
            return;
        }

        // ✅ Это текущий чат
        if (data.from_id !== user?.id) {
            playNotificationSoundFive();
        }

        // Загружаем оригинальное сообщение (если нужно)
        if (data.original_message_id && !data.original_message) {
            try {
                const response = await api.get(`/message?id=${data.original_message_id}`);
                data.original_message = response.data;
            } catch (error) {
                console.error('Failed to load original message:', error);
            }
        }
        
        // Добавляем сообщение в список
        const newMsg = {
            ...data,
            status: data.status,
            is_outgoing: data.from_id === user?.id,
            link_previews: data.link_previews || [],
            delivered_at: data.delivered_at || null,
            read_at: data.read_at || null
        };       
        setMessages(prev => {
            if (prev.some(m => m.id === newMsg.id)) {
                return prev;
            }
            return [...prev, newMsg];
        });
         // Обновляем в списке чатов
        if (data.from_id === user?.id) {
            // Это наше сообщение — сохраняем статус
            updateChat(data.chat_id, {
                last_message: newMsg
            });
        } else {
            // Это чужое сообщение
            updateChat(data.chat_id, {
                unread_count: (prev) => (prev || 0) + 1,
                last_message: newMsg
            });
        }        
    }
    
}, [user, updateChat]);
  // Загрузка истории сообщений
const loadMessages = useCallback( async (chatId) => {
      setLoading(true);
      try {
          const response = await api.get(`/messages?chat_id=${chatId}&limit=50`);
          // Проверяем, что response.data — массив
          if (!response.data || !Array.isArray(response.data)) {
              console.warn('Invalid response data:', response.data);
              setMessages([]);
              return [];
          }
          // Переворачиваем: старые сообщения будут сверху, новые снизу
          const messagesReversed = [...response.data].reverse();
          // Устанавливаем is_outgoing для ВСЕХ сообщений
          const messagesWithOutgoing = messagesReversed.map(msg => ({
              ...msg,
              is_outgoing: msg.from_id === user?.id
          }));
          
          setMessages(messagesWithOutgoing);     
         
          
          // Даём время на рендер
        setTimeout(async () => {
            await waitForMediaToLoad();
            // Находим первое непрочитанное
            const firstUnreadIndex = messagesWithOutgoing.findIndex(msg => 
                !msg.is_outgoing && !msg.read_at
            );
            setFirstUnreadIndex(firstUnreadIndex);
        }, 10);
          
          return messagesWithOutgoing;
          
      } catch (error) {
          console.error('Failed to load messages:', error);
          return [];
      } finally {
          setLoading(false);
      }
  },[user?.id]);
 
  // Определяем, когда подгружать (скролл вверх)
  const handleScroll = async (e) => {
    const container = e.target;
    const isNearBottom = container.scrollHeight - container.scrollTop - container.clientHeight < 150;
    shouldAutoScrollRef.current = isNearBottom;
    setShowScrollButton(!isNearBottom);
    if (container.scrollTop === 0 && hasMore && !isLoadingMore && currentChat) {
        // Сохраняем текущий chat_id
        const chatId = currentChat.chat_id;
        
        const oldScrollHeight = container.scrollHeight;
         const oldScrollTop = container.scrollTop;
        setIsLoadingMore(true);
        const offset = messages.length;
        
        try {
            const response = await api.get(`/messages?chat_id=${chatId}&limit=50&offset=${offset}`);
            
            // Проверяем, что чат не сменился
            if (currentChat?.chat_id !== chatId) return;
            
            const newMessages = response.data;
             setFirstUnreadIndex(-1);
            if (newMessages && Array.isArray(newMessages) && newMessages.length > 0) {
                const newMessagesWithOutgoing = newMessages.map(msg => ({
                    ...msg,
                    is_outgoing: msg.from_id === user?.id
                }));
                skipAutoScroll.current = true;
                // Фильтруем дубликаты по ID
                setMessages(prev => {
                    const existingIds = new Set(prev.map(m => m.id));
                    const uniqueNewMessages = newMessagesWithOutgoing.filter(msg => !existingIds.has(msg.id));
                    if (uniqueNewMessages.length === 0) return prev;
                    return [...uniqueNewMessages.reverse(), ...prev];
                });
                
               /*  setTimeout(() => {
                    if (currentChat?.chat_id !== chatId) return;
                    const newScrollHeight = container.scrollHeight;
                    container.scrollTop = newScrollHeight - oldScrollHeight;
                }, 50); */
                requestAnimationFrame(() => {
                    requestAnimationFrame(() => {
                        if (currentChat?.chat_id !== chatId) return;
                        const newScrollHeight = container.scrollHeight;
                        // Сдвигаем на разницу высот, оставаясь на том же контенте
                        container.scrollTop = oldScrollTop + (newScrollHeight - oldScrollHeight);
                    });
                });
            }
            const hasNoMoreMessages = !newMessages || newMessages.length < 50;
            if (hasNoMoreMessages) setHasMore(false);
            
        } catch (error) {
            console.error('Failed to load more messages:', error);
        } finally {
            setIsLoadingMore(false);
        }
    }
  };
// Функция, которая ждёт загрузки всех медиа в сообщениях (НОВАЯ версия)
const waitForMediaToLoad = () => {
    // Селекторы для поиска медиа или их контейнеров
    const selectors = '.attachment-image, .attachment-video, .attachment-audio, .image-gallery, .waveform-player';
    const wrappers = document.querySelectorAll(selectors);
    
    const allPromises = [];
    

    wrappers.forEach(el => {
        // Находим ВСЕ медиа-теги внутри текущего элемента
        // Если сам элемент является медиа-тегом, querySelectorAll его не найдет, поэтому проверяем и его
        const mediaElements = el.matches('img, video, audio') 
            ? [el] 
            : Array.from(el.querySelectorAll('img, video, audio'));

        mediaElements.forEach(media => {
            const tag = media.tagName;

            if (tag === 'IMG') {
                const imgPromise = new Promise(resolve => {
                    if (media.complete && media.naturalWidth > 0) {
                        resolve();
                    } else {
                        media.addEventListener('load', resolve, { once: true });
                        media.addEventListener('error', resolve, { once: true });
                    }
                });
                allPromises.push(imgPromise);
            }

            if (tag === 'VIDEO' || tag === 'AUDIO') {
                const mediaPromise = new Promise(resolve => {
                    if (media.readyState >= 2) {
                        resolve();
                    } else {
                        media.addEventListener('canplay', resolve, { once: true });
                        media.addEventListener('error', resolve, { once: true });
                    }
                });
                allPromises.push(mediaPromise);
            }
        });
    });   

    // Если медиа-элементов вообще не нашлось, Promise.all завершится мгновенно
    return Promise.all(allPromises);
};
  // Рендер разделителя дат
  const renderDateSeparator = (date, index, messages) => {
    if (index === 0) {
      // Первое сообщение — всегда показываем дату
      return (
        <div key={`sep-${date}`} className="date-separator">
          <span>{formatDateHeader(date)}</span>
        </div>
      );
    }
    
    // Проверяем, нужно ли показывать разделитель
  const prevDate = messages[index - 1]?.created_at;
    if (prevDate) {
      const prevDateOnly = new Date(prevDate).toDateString();
      const currentDateOnly = new Date(date).toDateString();
      if (prevDateOnly !== currentDateOnly) {
        return (
          <div key={`sep-${date}`} className="date-separator">
            <span>{formatDateHeader(date)}</span>
          </div>
        );
      }
    }
    return null;
  };
  // Выбор чата
  const selectChat = useCallback (async (chat) => {
      if (!user) return;
      currentChatIdRef.current = chat.chat_id;
      setCurrentChat(chat);       
      setReplyTo(null);
      setMessages([]);
    setHasMore(true);
    setIsLoadingMore(false);
    setFirstUnreadIndex(-1);
    setTypingMessage(null);
     setShowScrollButton(false);
    await loadMessages(chat.chat_id);      
      setTimeout(() => scrollToBottom(), 200);
  }, [user, loadMessages]); 
  // Отметить как прочитанные
const markAsRead = useCallback((chatId, lastMessageId) => {
    if (lastMarkedReadRef.current[chatId] >= lastMessageId) {
        return;
    }
    lastMarkedReadRef.current[chatId] = lastMessageId;
    // ✅ Отправляем через WebSocket
    if (!wsRef.current || wsRef.current.readyState !== WebSocket.OPEN) {        
        return;
    }
     wsRef.current.send(JSON.stringify({
            type: 'mark_read',
            chat_id: chatId,
            last_message_id: lastMessageId
        }));
    // ✅ Обновляем UI локально
    setChats(prev => prev.map(chat => 
        chat.chat_id === chatId ? { ...chat, unread_count: 0 } : chat
    ));
    
    setMessages(prev => prev.map(msg => 
        msg.chat_id === chatId && !msg.is_outgoing && msg.id <= lastMessageId
            ? { ...msg, read_at: new Date().toISOString() }
            : msg
    ));
}, []);
  // Отправка сообщения
const sendMessage = async () => {
    if (!inputMessage.trim()) return;
    if (editingMessage) {
        saveEditedMessage();
        return;
    }
    resetTyping();
    
    if (!wsRef.current || wsRef.current.readyState !== WebSocket.OPEN) {
      console.error('WebSocket not connected');
      // ✅ Сохраняем черновик (только текст и replyTo)
        saveDraftMessage(
            currentChat.chat_id,
            inputMessage,
            null, // attachments нет
            replyTo
        );       
       // showNotification('Нет соединения. Сообщение сохранено.', 'warning');
        
        setInputMessage('');
        setReplyTo(null);
        setReplyToMessage(null);
        // ✅ Принудительно переподключаемся
        reconnectAttemptsRef.current = 0; // Сбрасываем счетчик
        isConnectingRef.current = false;   // Сбрасываем флаг
        if (typeof connectWebSocketRef.current === 'function') {
            connectWebSocketRef.current();
        }
        if (textareaRef.current) {
            textareaRef.current.style.height = 'auto';
        }              
      return ;
    }
    
     try {
        const urls = extractUrls(inputMessage);
        const linkPreviews = [];
        for (const url of urls) {
            const preview = await fetchLinkPreview(url);
            if (preview) linkPreviews.push(preview);
        }        
       
        const message = {
            type: 'text',
            chat_id: currentChat.chat_id,
            content: inputMessage,
            link_previews: linkPreviews
        };
        
        if (replyTo) {
            message.reply_to_id = replyTo.id;
        }

        wsRef.current.send(JSON.stringify(message));
             
        setInputMessage('');
        setReplyTo(null);
        setReplyToMessage(null);
        
        if (textareaRef.current) {
            textareaRef.current.style.height = 'auto';
        }       
       
       setTimeout(() => scrollToBottom(), 100);     
    } catch (error) {
        console.error('Failed to send message:', error);
        showNotification('Ошибка отправки сообщения', 'error');       
        // ✅ При ошибке сохраняем черновик
        saveDraftMessage(
            currentChat.chat_id,
            inputMessage,
            null,
            replyTo
        );
    } 
      
  };
  // Функция отправки медиа-сообщения
const sendMediaMessage = async () => {
      if (attachments.length === 0) return;
       if (isUploading) return;                 
      setIsUploading(true);
    setUploadProgress(0);
      const formData = new FormData();
      formData.append('chat_id', currentChat.chat_id);
      if (replyTo) {
          formData.append('reply_to_id', replyTo.id);
      }
      if (inputMessage.trim()) {
          formData.append('caption', inputMessage);
      }    
      attachments.forEach(file => {
          formData.append('files', file);
      });
      
      try {
          await api.post(`/upload`, formData, {
            headers: { 'Content-Type': 'multipart/form-data' },
            timeout: TIMEOUT_UPLOAD, // 10 минут
            maxContentLength: Infinity,
            maxBodyLength: Infinity,
               onUploadProgress: (progressEvent) => {
                const percent = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                setUploadProgress(percent);
                }
          });
          
          setInputMessage('');
          setAttachments([]);
          setReplyTo(null);
          setReplyToMessage(null);
           if (textareaRef.current) {
                textareaRef.current.style.height = 'auto';
            }
          setTimeout(() => scrollToBottom(), 200);
      } catch (error) {
          // ✅ Проверяем тип ошибки
        const isNetworkError = !error.response || error.code === 'ECONNABORTED' || error.message === 'Network Error';
        
        if (isNetworkError) {
           // showNotification('Нет соединения. Файлы сохранены.', 'warning');
            // Сохраняем черновик с файлами
            saveDraftMessage(
                currentChat.chat_id,
                inputMessage,
                attachments, // ✅ здесь есть attachments!
                replyTo
            );
            setInputMessage('');
            setAttachments([]);
            setReplyTo(null);
            setReplyToMessage(null);
        } else {
            showNotification('Ошибка отправки файлов. Попробуйте позже.', 'error');
        }
      } finally {
         
          setIsUploading(false);
        setUploadProgress(0);
      }
  };
const sendStickerMessage = async (stickerData) =>{

    if (!wsRef.current || wsRef.current.readyState !== WebSocket.OPEN) {
        console.warn('⚠️ WebSocket not connected, reconnecting...');
        
        // ✅ Сохраняем в черновик
        saveDraftMessage(
            currentChat.chat_id,
            null, // текста нет
            null, // вложений нет
            replyTo,
            { type: 'sticker', content: stickerData.content.url } // ← стикер
        );
        
        // ✅ Принудительно переподключаемся
        reconnectAttemptsRef.current = 0;
        isConnectingRef.current = false;
        if (typeof connectWebSocketRef.current === 'function') {
            connectWebSocketRef.current();
        }
        
        return;
    }
    try {        
        const message = {
            type: 'sticker',
            chat_id: currentChat.chat_id,
            content: stickerData.content.url,
            
        };
        
        wsRef.current.send(JSON.stringify(message));
          setTimeout(() => scrollToBottom(), 100);  
    } catch (error) {
         console.error('Failed to send message:', error);
         showNotification('Ошибка отправки сообщения', 'error');       
        // ✅ При ошибке сохраняем черновик
        saveDraftMessage(
            currentChat.chat_id,
            null,
            null,
            replyTo,
             { type: 'sticker', content: stickerData.content.url }
        );
    }
  };
const startEditing = (msg) => {
    setEditingMessage(msg);
    setInputMessage(msg.content || '');
    setAttachments(msg.attachments || []);
    
};
const sendOrEditMessage = async () => {
    if (editingMessage) {
        // Редактируем существующее сообщение
        await saveEditedMessage();
        return;
    } else if (attachments.length > 0) {
        // Отправляем медиа
        await sendMediaMessage();
    } else {
        // Отправляем текст
        await sendMessage();
    }
};
//Функция сохранения изменений
const saveEditedMessage = async () => {
    if (!inputMessage.trim() && attachments.length === 0) {
        showNotification('Сообщение не может быть пустым', 'warning');
        return;
    }    
    try {       
        await api.put(`/messages/edit`, {
            message_id: editingMessage.id,
            content: inputMessage        
        });
        
        setEditingMessage(null);
        setInputMessage('');
        /* setAttachments([]);
        setReplyTo(null); */
        showNotification('Сообщение изменено', 'success');
        
    } catch (error) {
        console.error('Failed to edit message:', error);
        showNotification('Ошибка редактирования', 'error');
    }
};
 // Функция сохранения черновика
const saveDraftMessage = (chatId, text, attachments = null, replyTo = null, sticker = null) => {
    try {
        const drafts = JSON.parse(localStorage.getItem('message_drafts') || '{}');
        if (!drafts[chatId]) {
            drafts[chatId] = [];
        }
        
        // ✅ Сохраняем только то, что есть
        const draft = {
            text: text || '',
            timestamp: new Date().toISOString(),
            pending: true
        };
        
        // ✅ Добавляем replyTo если есть
        if (replyTo) {
            draft.replyTo = replyTo;
        }
        
        // ✅ Добавляем attachments если есть
        if (attachments && attachments.length > 0) {
            draft.attachments = attachments;
        }
        if (sticker) draft.sticker = sticker;
        drafts[chatId].push(draft);
        localStorage.setItem('message_drafts', JSON.stringify(drafts));        
        console.log('💾 Draft saved:', draft);
    } catch (error) {
        console.error('Failed to save draft:', error);
    }
};
// Функция отправки черновиков
const sendPendingMessages = useCallback(() => {
    if (!wsRef.current || wsRef.current.readyState !== WebSocket.OPEN) {        
        return;
    }
    
    const drafts = JSON.parse(localStorage.getItem('message_drafts') || '{}');
    let hasPending = false;
    
    Object.keys(drafts).forEach(chatId => {
        const pendingMessages = drafts[chatId] || [];
        const remaining = [];
        
        pendingMessages.forEach(msg => {
            if (msg.pending) {
                try {
                    if (msg.sticker) {
                        const message = {
                            type: 'sticker',
                            chat_id: chatId,
                            content: msg.sticker.content
                        };
                        wsRef.current.send(JSON.stringify(message));
                        msg.pending = false;
                        console.log('✅ Pending sticker sent');
                    }
                    // ✅ Если есть attachments - отправляем через HTTP
                    else if (msg.attachments && msg.attachments.length > 0) {
                        const formData = new FormData();
                        formData.append('chat_id', chatId);
                        if (msg.replyTo) {
                            formData.append('reply_to_id', msg.replyTo.id);
                        }
                        if (msg.text) {
                            formData.append('caption', msg.text);
                        }
                        msg.attachments.forEach(file => {
                            formData.append('files', file);
                        });
                        
                        api.post('/upload', formData, {
                            headers: { 'Content-Type': 'multipart/form-data' }
                        }).then(() => {
                            console.log('✅ Pending media sent');
                            msg.pending = false;
                        }).catch(err => {
                            console.error('Failed to send pending media:', err);
                            remaining.push(msg);
                        });
                    } else {
                        // ✅ Текстовое сообщение через WebSocket
                        const message = {
                            type: 'text',
                            chat_id: chatId,
                            content: msg.text || '',
                            link_previews: []
                        };                        
                        if (msg.replyTo) {
                            message.reply_to_id = msg.replyTo.id;
                        }                        
                        wsRef.current.send(JSON.stringify(message));
                        msg.pending = false;
                        console.log('✅ Pending message sent');
                    }
                } catch (error) {
                    console.error('Failed to send pending message:', error);
                    remaining.push(msg);
                }
            } else {
                remaining.push(msg);
            }
        });        
        if (remaining.length > 0) {
            drafts[chatId] = remaining;
            hasPending = true;
        } else {
            delete drafts[chatId];
        }
    });    
    if (!hasPending) {
        localStorage.removeItem('message_drafts');
    } else {
        localStorage.setItem('message_drafts', JSON.stringify(drafts));
    }
}, []);
  //
const handleFileSelect = (e) => {
    const files = Array.from(e.target.files);
    if (files.length + attachments.length > 20) {
        showNotification('Можно загрузить не более 20 файлов', 'warning');
        return;
    }
    setAttachments([...attachments, ...files]);
};
// Функция удаления прикрепленного файла
const removeAttachment = (index) => {
    setAttachments(attachments.filter((_, i) => i !== index));
}; 
// Подтверждение удаления
const confirmDelete = async () => {
if (!messageToDelete) return;

const deleteForAll = messageToDelete.is_outgoing === true;

setLoading(true);
setShowDeleteConfirm(false);

try {
    await api.post(`/messages/delete`, 
    null,
    {
        params: {
        message_id: messageToDelete.id,
        delete_for_all: deleteForAll
        }
    }
    );     
    
    setMessageToDelete(null);
    
} catch (error) {
    console.error('Failed to delete message:', error);
    showNotification('Ошибка удаления сообщения', 'warning');
} finally {
    setLoading(false);
}
};
// Отмена удаления
const cancelDelete = () => {
setShowDeleteConfirm(false);
setMessageToDelete(null);
};
//Функция создания группы 
const handleCreateGroup = async ({ title, memberIds, avatarFile }) => {
setLoading(true);
try {
    // 1. Создаём группу
    const response = await api.post('/groups/', {
            title: title,
        members: memberIds,
    });
    console.log('Group created:', response.data);
    const groupId = response.data.id;

    // 2. Загружаем аватар, если есть
    if (avatarFile) {
        const formData = new FormData();
        formData.append('avatar', avatarFile);      

        await api.post(`/groups/avatar?group_id=${groupId}`, formData, {
            headers: { 'Content-Type': 'multipart/form-data' },
        });
    }

    // 3. Обновляем список чатов
    if (loadChatsRef.current) loadChatsRef.current();
    showNotification('Группа создана', 'info');
} catch (error) {
    console.error('Failed to create group:', error);
        if (error.response?.status === 409) {
        showNotification('Группа с таким названием уже существует', 'error');
        
    } else {
        showNotification('Ошибка создания группы', 'error');
    }
    throw error;
} finally {
    setLoading(false);
}
};
  // Сохранение изменений группы
const handleSaveGroup = async ({ name, avatarFile }) => {
    if (!editingGroup) return;
    setLoading(true);
    try {
        const groupId = editingGroup.chat_id.replace('group_', '');

        // Обновляем название
        await api.put(`/groups/${groupId}`, { title: name });

        // Загружаем аватар, если есть
        if (avatarFile) {
            const formData = new FormData();
            formData.append('avatar', avatarFile);            

            await api.post(`/groups/avatar?group_id=${groupId}`, formData, {
                headers: { 'Content-Type': 'multipart/form-data' },
            });
        }

        // Обновляем список
        if (loadChatsRef.current) loadChatsRef.current();
        
        // Обновляем currentChat если это текущий чат
        if (currentChat?.chat_id === editingGroup.chat_id) {
            setCurrentChat(prev => ({ ...prev, title: name }));
        }

        showNotification('Группа обновлена', 'info');
    } catch (error) {
        console.error('Failed to update group:', error);
        if (error.response?.status === 409) {
            showNotification('Группа с таким названием уже существует', 'error');
            
        } else {
            showNotification('Ошибка обновления группы', 'error');
        }
        throw error;
    } finally {
        setLoading(false);
    }
};
// Функция удаления группы  
const handleDeleteGroup = async (group) => {
    setConfirmModal({
        show: true,
        title: 'Удалить группу',
        message: `Удалить группу "${group.title}"? Все сообщения будут потеряны.`,
        danger: true,
        onConfirm: async () => {      
            try {
                const groupId = group.chat_id.replace('group_', '');
                await api.delete(`/groups/${groupId}`);                
                // Удаляем чат из списка
                setChats(prev => prev.filter(c => c.chat_id !== group.chat_id));
                
                // Если удалённый чат был текущим — переключаемся на другой
                if (currentChat?.chat_id === group.chat_id) {
                    setCurrentChat(null);
                    setMessages([]);
                }                
                showNotification('Группа удалена', 'success');                
            } catch (error) {
                console.error('Failed to delete group:', error);
                showNotification('Ошибка удаления группы', 'error');
            }
        }, 
    });
};
// Приглашение участников
const handleInvite = async (userIds) => {
    if (!inviteGroup) return;

    try {
        const groupId = inviteGroup.chat_id.replace('group_', '');

      
        await api.post(`/groups/invite?group_id=${groupId}`, {
            user_ids: userIds,
        });

        if (loadChatsRef.current) loadChatsRef.current();

        showNotification(`Приглашено: ${userIds.length}`, 'info');
    } catch (error) {
        console.error('Failed to invite:', error);
        showNotification('Ошибка приглашения', 'error');
        throw error;
    }
};    
  // Функция отправки пересылки 
const sendForward = async (recipients, comment) => {
if (!forwardMessage) return;

try {
    for (const recipient of recipients) {
        const message = {
            type: 'text',
            chat_id: recipient.chat_id,
            content: comment || '',
            is_forwarded: true,
            forward_from: {
                id: forwardMessage.from_id,
                username: forwardMessage.from_username,
                display_name: forwardMessage.display_name,
            },
            original_message_id: forwardMessage.id,
        };
        
        if (wsRef.current && wsRef.current.readyState === WebSocket.OPEN) {
            wsRef.current.send(JSON.stringify(message));
        }
    }
    
    setShowForwardModal(false);
    setForwardMessage(null);
} catch (error) {
    console.error('Failed to forward:', error);
    throw error;
}
};  
// Выход
const logout = () => {
console.log('Выход....')
dataLoadedRef.current = false;
localStorage.removeItem('access_token');
localStorage.removeItem('refresh_token');
setToken('');
setUser(null);
setChats([]);
setCurrentChat(null);
clearFileCache();
if (wsRef.current) {
    wsRef.current.close();
}
}; 
// Функция скачивания файла
const downloadFile = async (att) => {
    try {
        const response = await api.get(`${att.media_url}?download=1`, {
            responseType: 'blob'
        });
        
        const blob = new Blob([response.data]);
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = att.file_name; // оригинальное имя
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
    } catch (error) {
        console.error('Download failed:', error);
    }
};
// Обработчик изменения состояния воспроизведения
const handlePlayStateChange = (id, isPlaying) => {
if (isPlaying) {
    // Если плеер начал играть - запоминаем его ID
    setActivePlayerId(id);
} else if (activePlayerId === id) {
    // Если текущий плеер остановился - сбрасываем ID
    setActivePlayerId(null);
}
};  
// Поиск пользователей
const searchUsers = useCallback(async (query) => {
if (!query.trim()) {
    setSearchResults([]);
    return;
}
setSearching(true);
try {
    const response = await api.get(`/users/search?q=${encodeURIComponent(query)}`);
    const users = Array.isArray(response.data) ? response.data : [];
    // Проверка: chats должен быть массивом
    const existingChatIds = Array.isArray(chats) ? chats.map(chat => {
    if (chat.type === 'private') {
        const match = chat.chat_id?.match(/private_(\d+)_(\d+)/);
        if (match) {
        const otherId = parseInt(match[1]) === user?.id ? parseInt(match[2]) : parseInt(match[1]);
        return otherId;
        }
    }
    return null;
    }).filter(id => id !== null) : [];
    
    const filtered = users.filter(u => u && u.id != null && !existingChatIds.includes(u.id));
    setSearchResults(filtered);
} catch (error) {
    console.error('Search failed:', error);
    setSearchResults([]);
} finally {
    setSearching(false);
}
}, [user, chats]);
// поиск пользователей для добавления в группу 
const searchUsersForGroup = async (query) => {
try {
    const response = await api.get(`/users/all?q=${encodeURIComponent(query)}`);        
    const users = Array.isArray(response.data) ? response.data : [];       
    // Фильтруем: только те, с кем есть приватный чат
    const contactIds = getContactUserIds();        
        const userFiltered = users.filter(u => 
        u && u.id != null && contactIds.includes(Number(u.id))
    );        
    return userFiltered;
} catch (error) {
    console.error('Search failed:', error);
    return [];
}
}; 
// Создание приватного чата
const createPrivateChat = async (otherUser) => {
if (!user) return;

setLoading(true);
try {
    const minId = Math.min(user.id, otherUser.id);
    const maxId = Math.max(user.id, otherUser.id);
    const chatId = `private_${minId}_${maxId}`;
    
    // Проверяем, существует ли уже чат
    const existsResponse = await api.get(`/chats/exists?user_id=${otherUser.id}`);
    
    if (existsResponse.data.exists) {
    showNotification('Чат с этим пользователем уже существует!', 'warning');
    const existingChat = Array.isArray(chats) ? chats.find(c => c.chat_id === chatId) : null;
    if (existingChat) {
        selectChat(existingChat);
    }
    setShowNewChat(false);
    setSearchQuery('');
    setSearchResults([]);
    return;
    }
    
    const welcomeMessage = `Привет, ${otherUser.display_name}! Я использую MesDs для общения! Присоединяйся!`;
    
    if (wsRef.current && wsRef.current.readyState === WebSocket.OPEN) {
    wsRef.current.send(JSON.stringify({
        type: 'text',
        chat_id: chatId,
        content: welcomeMessage
    }));
    }
    
    setTimeout(async () => {
    if (typeof loadChatsRef.current === 'function') {
            loadChatsRef.current(); 
        }
    const newChat = Array.isArray(chats) ? chats.find(c => c.chat_id === chatId) : null;
    if (newChat) {
        selectChat(newChat);
    }
    }, 500);
    
    setShowNewChat(false);
    setSearchQuery('');
    setSearchResults([]);
} catch (error) {
    console.error('Failed to create chat:', error);
    showNotification('Ошибка создания чата', 'error');
} finally {
    setLoading(false);
}
};

// Контекстное меню для сообщений
const handleMessageContextMenu = (e, msg) => {
if (e.cancelable) {
e.preventDefault();
}
// Определяем позицию
const x = e.clientX || (e.touches ? e.touches[0].clientX : 0);
const y = e.clientY || (e.touches ? e.touches[0].clientY : 0);

let canDelete = false;
if (msg.from_id === user?.id) {
    // Своё сообщение — можно удалить (для всех)
    canDelete = true;
}
    // Чужое сообщение в приватном чате — можно удалить только для себя
    else if (currentChat?.type === 'private' && msg.from_id !== user?.id) {
        canDelete = true;  // Удаляем только для себя
    }
    else if (currentChat?.type === 'group' && currentChat.created_by === user?.id && msg.from_id !== user?.id) {
        canDelete = true;
    }

const isOutgoing = msg.is_outgoing !== undefined ? msg.is_outgoing : (msg.from_id === user?.id);
const items = [
    { label: 'Ответить', icon: 'bi-reply',  onClick: () => { setReplyTo(msg);setReplyToMessage(msg);} },
    { label: 'Переслать', icon: 'bi-share', onClick: () => { setForwardMessage(msg); setShowForwardModal(true); }},
    { label: 'Копировать', icon: 'bi-files', onClick: () => navigator.clipboard.writeText(msg.content) },      
    { label: 'Выделить', icon: 'bi-pin', onClick: () => console.log('Select', msg.id) },
    { divider: true },
];

if (isOutgoing && msg.type === 'text') {
    items.push({ 
    label: 'Редактировать', 
    icon: 'bi-pencil', 
        onClick: () => startEditing(msg)});
}
if (canDelete) {
        items.push({ 
        label: 'Удалить', 
        icon: 'bi-trash', 
        danger: true,  
        onClick: () => {
            setMessageToDelete(msg);
            setShowDeleteConfirm(true);
        }
        });
    } else {
        // Показываем disabled пункт или ничего
        items.push({ 
            label: 'Удалить (недоступно)', 
            icon: 'bi-trash', 
            disabled: true,             
        });
    }     

setContextMenuModal({ x, y, items, message: msg });
};  
// Для чатов
const handleChatContextMenu = (e, chat) => {
// e.preventDefault();

let items = [];

if (chat.type === 'private') {
    items = [
    { label: 'Удалить чат', icon: 'bi-trash', danger: true, onClick: () => console.log('Delete chat', chat.chat_id) },
    ];
} else {
    const isCreator = chat.created_by === user?.id;
    
    if (isCreator) {
    items = [
        { label: 'Пригласить в группу', icon: 'bi-person-plus', onClick: () => { 
            setInviteGroup(chat); 
            setShowInviteModal(true); 
        }  },
        { label: 'Удалить из группы', icon: 'bi-person-dash', onClick: () => console.log('Remove member', chat.chat_id) },
        { label: 'Редактировать группу', icon: 'bi-pencil', onClick: () => { 
            setEditingGroup(chat); 
            setShowEditGroupModal(true); 
        }  },
        { label: 'Очистить группу', icon: 'bi-eraser', onClick: () => console.log('Clear group', chat.chat_id) },
        { label: 'Закрыть группу', icon: 'bi-x-circle', danger: true, onClick: () => handleDeleteGroup(chat) },
    ];
    } else {
    items = [
        { label: 'Выйти из группы', icon: 'bi-box-arrow-right', danger: true, onClick: () => console.log('Leave group', chat.chat_id) },
    ];
    }
}

setContextMenu({ x: e.clientX, y: e.clientY, items });
// setContextMenuTarget(chat);
// setContextMenuType('chat');
};
// Для профиля
const handleUserContextMenu = (e) => {
e.preventDefault();

const items = [
    { label: 'Редактировать профиль', icon: 'bi-person-gear', onClick: () => setShowProfileModal(true) },
    { label: 'Создать группу', icon: 'bi-people-fill', onClick: () => setShowCreateGroup(true) },
    { label: 'Настройки', icon: 'bi-gear', onClick: () => console.log('Settings') },
    { label: 'Выйти', icon: 'bi-box-arrow-right', danger: true, onClick: () =>
    showConfirm(
        'Выход', 
        `Вы уверены, что хотите выйти из приложения?`,
        logout,
        true
    )
    },
];

setContextMenu({ x: e.clientX, y: e.clientY, items });    
};
// Скролл к сообщению
const scrollToMessage = (messageId) => {
const element = document.getElementById(`message-${messageId}`);
if (element) {
    element.scrollIntoView({ behavior: 'smooth' });
}
};

const scrollToBottom = () => {
messagesEndRef.current?.scrollIntoView({ behavior: 'auto' });
};

// Переход к оригинальному сообщению при клике на пересланное
const goToOriginalMessage = async (originalMessage) => {
        
    // Ищем чат по exact совпадению
    const targetChat = chats.find(chat => chat.chat_id === originalMessage.chat_id);
    
    if (targetChat) {          
        setCurrentChat(targetChat);
        await loadMessages(targetChat.chat_id);
        
        setTimeout(() => {
            const element = document.getElementById(`message-${originalMessage.id}`);
            if (element) {
                element.scrollIntoView({ behavior: 'smooth', block: 'center' });
                element.style.transition = 'background 0.5s';
                element.style.background = '#2a4a6a';
                setTimeout(() => {
                    element.style.background = '';
                }, 2000);
            } else {
                console.log('Message element not found:', originalMessage.id);
            }
        }, 300);
    } else {
        console.error('Chat not found:', originalMessage.chat_id);
        showNotification('Чат с оригинальным сообщением не найден', 'warning');
    }
};
// Получение превью ссылки
const fetchLinkPreview = async (url) => {
    try {
        const response = await api.get(`/link-preview?url=${encodeURIComponent(url)}`);
        return response.data;
    } catch (error) {
        console.error('Failed to fetch link preview:', error);
        return null;
    }
};
//Функция обработки вставки  
const handlePaste = (e) => {
    const clipboardData = e.clipboardData;
    const items = clipboardData.items;
    const newFiles = [];
    
    for (let i = 0; i < items.length; i++) {
        const item = items[i];
        
        if (item.kind === 'file') {
            const file = item.getAsFile();
            if (file) {
                newFiles.push(file);
            }
        }
    }      
    if (newFiles.length > 0) {
        e.preventDefault();
        
        if (attachments.length + newFiles.length > MAX_FILES_COUNT) {
            showNotification(`Можно загрузить не более ${MAX_FILES_COUNT} файлов за раз`, 'warning');
            return;
        }
        
        setAttachments([...attachments, ...newFiles]);
    }
};
// Drag-and-Drop
const handleDragOver = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(true);
};
// Когда курсор покидает область дропа
const handleDragLeave = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(false);
};
// Когда файл отпускают в области дропа
const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(false);
    
    const files = Array.from(e.dataTransfer.files);
    if (files.length === 0) return;
    
    if (attachments.length + files.length > MAX_FILES_COUNT) {
        showNotification(`Можно загрузить не более ${MAX_FILES_COUNT} файлов за раз`, 'warning');
        return;
    }      
    setAttachments([...attachments, ...files]);
};
// Получение ID другого пользователя в приватном чате
const getOtherUserId = (chatId) => {
    // chatId имеет формат private_1_2
    const parts = chatId.split('_');
    if (parts.length === 3) {
        const id1 = parseInt(parts[1]);
        const id2 = parseInt(parts[2]);
        return id1 === user?.id ? id2 : id1;
    }
    return null;
};
const getContactUserIds = useCallback( () => {
const ids = new Set();
chats.forEach(chat => {
    if (chat.type === 'private') {
        const parts = chat.chat_id.split('_');
        if (parts.length === 3) {
            const id1 = parseInt(parts[1]);
            const id2 = parseInt(parts[2]);
            const otherId = id1 === user?.id ? id2 : id1;
            ids.add(otherId);
        }
    }
});
return Array.from(ids);
},[chats, user?.id]);
const handleStartCall = (chat, isVideo) => {
    const otherUserId = getOtherUserId(chat.chat_id);
    startCall(chat.chat_id, otherUserId, isVideo);
};

// Функция начала звонка НОВАЯ ВЕРСИЯ
const startCall = async (chatId, otherUserId, isVideo, isCaller = true) => {
    console.log('startCall:', { chatId, otherUserId, isVideo, isCaller });
    
    try {
        // Получаем токен
        const response = await fetch(`${API_URL}/livekit/token?room=${chatId}&user_id=${user.id}`);
        const { token } = await response.json();

        // Находим название чата
        const chat = chats.find(c => c.chat_id === chatId);
        const chatTitle = chat?.title || 'Собеседник';

        // Открываем CallModal
        setActiveCall({ token, chatId, otherUserId, isVideo, chatTitle });

        // Уведомляем собеседника через WebSocket (только инициатор)
        if (isCaller && wsRef.current?.readyState === WebSocket.OPEN) {
            wsRef.current.send(JSON.stringify({
                type: 'call',
                action: 'offer',
                chat_id: chatId,
                to_user_id: otherUserId,
                from_user_id: user.id,
                from_name: user.displayName || user.username,
                room: chatId,
                is_video: isVideo
            }));
        }
    } catch (error) {
        console.error('Failed to start call:', error);
        showNotification('Не удалось начать звонок', 'error');
    }
};

const acceptIncomingCall = async () => {
    if (!incomingCall) return;
     stopRingtone();
    const call = incomingCall;
    setIncomingCall(null);
    
    // Подключаемся без отправки offer
    await startCall(call.chatId, call.fromUserId, call.isVideo, false);
    
    // Отправляем accept
    if (wsRef.current?.readyState === WebSocket.OPEN) {
        wsRef.current.send(JSON.stringify({
            type: 'call',
            action: 'accept',
            chat_id: call.chatId,
            to_user_id: call.fromUserId,
            room: call.room
        }));
    }
};

const rejectIncomingCall = () => {
     stopRingtone();
    if (incomingCall && wsRef.current?.readyState === WebSocket.OPEN) {
        wsRef.current.send(JSON.stringify({
            type: 'call',
            action: 'reject',
            chat_id: incomingCall.chatId,
            to_user_id: incomingCall.fromUserId,
            room: incomingCall.room
        }));
    }
    setIncomingCall(null);
};

// Функция окончания звонка НОВАЯ ВЕРСИЯ
const endCall = useCallback((sendNotification = true, chatId = null, otherUserId = null) => {
     stopRingtone();
    const targetChatId = chatId || activeCall?.chatId;
    const targetUserId = otherUserId || activeCall?.otherUserId;
    if (sendNotification && targetChatId && targetUserId && wsRef.current?.readyState === WebSocket.OPEN) {
        const endData = {
            type: 'call',
            action: 'end',
            chat_id: targetChatId,
            to_user_id: targetUserId,
            room: targetChatId
        };
        console.log('Sending end call:', endData);
        wsRef.current.send(JSON.stringify(endData));
    }
    setActiveCall(null);
    setIncomingCall(null);
}, [activeCall]);
const closeMobileMenu = () => {
    setMobileMenuOpen(false);
};

const toggleMobileMenu = () => {
    setShowScrollButton(false);
    setMobileMenuOpen(!mobileMenuOpen);
    if (!mobileMenuOpen) {
    setCurrentChat(null);
    setMessages([]);
    setEditingMessage(null);
    setInputMessage('');
}
};
    // Функция для динамического определения поддерживаемого формата
const getSupportedMimeType = () => {
    const types = [
        'audio/webm;codecs=opus',
        'audio/webm',
        'audio/ogg',
        'audio/mp4', // Спасение для iOS
        'audio/aac'
    ];
    for (const type of types) {
        if (MediaRecorder.isTypeSupported(type)) {
            return type;
        }
    }
    return ''; // Если ничего не поддерживается (редкий случай)
};
  // Функция получения длительности аудио (фикс для iOS)
const getAudioDuration = (file) => {
    return new Promise((resolve) => {
        const audio = new Audio();
        const objectUrl = URL.createObjectURL(file);
        
        audio.preload = 'metadata';
        audio.muted = true; // Фикс для iOS: аудио должно быть приглушено для авто-загрузки
        
        audio.onloadedmetadata = () => {
            URL.revokeObjectURL(objectUrl);
            resolve(Math.round(audio.duration) || 0);
        };

        audio.onerror = () => {
            URL.revokeObjectURL(objectUrl);
            resolve(0); // Возвращаем 0, если iOS заблокировал чтение метаданных
        };

        audio.src = objectUrl;
        audio.load(); // Фикс для iOS: принудительно заставляем браузер прочитать файл
    });
};
    
   // Начать запись (новая версия)
const startRecording = async () => {
    try {
        if (recordingTimerRef.current) {
            clearInterval(recordingTimerRef.current);
            recordingTimerRef.current = null;
        }
        
        setRecordingTime(0);
        setAudioChunks([]);
        
        const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
        
        // ОПРЕДЕЛЯЕМ МИМЕ-ТИП ДЛЯ КОНКРЕТНОЙ ПЛАТФОРМЫ
        const mimeType = getSupportedMimeType();
        const recorder = new MediaRecorder(stream, mimeType ? { mimeType } : {});
        
        let chunks = [];
        
        recorder.ondataavailable = (event) => {
            if (event.data.size > 0) {
                chunks.push(event.data);
            }
        };
        
        recorder.onstop = () => {
            if (recordingTimerRef.current) {
                clearInterval(recordingTimerRef.current);
                recordingTimerRef.current = null;
            }
            
            // Если мы отменили запись, не отправляем её
            if (recorder.isCancelled) {
                stream.getTracks().forEach(track => track.stop());
                return;
            }
            
            if (chunks.length > 0) {
                // Создаем Blob с правильным для платформы типом
                const finalMimeType = mimeType || recorder.mimeType || 'audio/mp4';
                const audioBlob = new Blob(chunks, { type: finalMimeType });
                
                // Подбираем правильное расширение файла
                const extension = finalMimeType.includes('webm') ? 'webm' : 'mp4';
                const audioFile = new File([audioBlob], `voice_${Date.now()}.${extension}`, { type: finalMimeType });
                
                sendVoiceMessage(audioFile);
            }
            
            setRecordingTime(0);
            setIsRecording(false);
            setMediaRecorder(null);
            stream.getTracks().forEach(track => track.stop());
        };
        
        recorder.start(100);
        setMediaRecorder(recorder);
        setIsRecording(true);
        
        recordingTimerRef.current = setInterval(() => {
            setRecordingTime(prev => {
                const nextTime = prev + 1;                
                // Если достигли лимита времени
                if (nextTime >= MAX_RECORDING_TIME) {
                    clearInterval(recordingTimerRef.current);
                    recordingTimerRef.current = null;                    
                    // Принудительно останавливаем запись (onstop сам отправит файл)
                    if (recorder && recorder.state !== 'inactive') {
                        recorder.stop();
                    }                    
                    showNotification('Достигнут максимальный лимит записи (3 минуты)', 'info');
                    return MAX_RECORDING_TIME;
                }                
                return nextTime;
            });
        }, 1000);
        
    } catch (error) {
        console.error('Microphone error:', error);
    
    if (error.name === 'NotReadableError') {
        showNotification('Микрофон занят другим приложением или недоступен. Перезагрузите страницу или устройство.', 'error');
    } else if (error.name === 'NotAllowedError' || error.name === 'PermissionDeniedError') {
        showNotification('Вы запретили доступ к микрофону в настройках браузера.', 'error');
    } else {
        showNotification('Не удалось получить доступ к микрофону', 'error');
    }
    }
};
   
    // Остановить запись (новая версия)
const stopRecording = () => {
    if (mediaRecorder && isRecording) {
        mediaRecorder.stop();
    }
};
  
    // Отправить голосовое сообщение (новая версия)
const sendVoiceMessage = async (audioFile) => {
    setIsUploading(true);
    setUploadProgress(0);
    const duration = await getAudioDuration(audioFile);
    const formData = new FormData();
    formData.append('chat_id', currentChat.chat_id);
    formData.append('files', audioFile);
    formData.append('duration', duration.toString());
    formData.append('is_voice', 'true');
    
    if (replyTo) {
        formData.append('reply_to_id', replyTo.id);
    }
    
    try {
        await api.post(`/upload`, formData, {
            headers: { 'Content-Type': 'multipart/form-data' },
            timeout: TIMEOUT_UPLOAD, // 10 минут
            maxContentLength: Infinity,
            maxBodyLength: Infinity,
               onUploadProgress: (progressEvent) => {
                const percent = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                setUploadProgress(percent);
                }
        });
        scrollToBottom();
    } catch (error) {
        console.error('Failed to send voice message:', error);
        showNotification('Ошибка отправки голосового сообщения', 'error');
    } finally {
         
          setIsUploading(false);
        setUploadProgress(0);
      }
};
// Отмена записи (переписано без создания утечек и дублирования onstop)
const cancelRecording = () => {
    if (mediaRecorder && isRecording) {
        mediaRecorder.isCancelled = true; // Флаг, чтобы onstop не отправлял файл
        mediaRecorder.stop();
        
        if (recordingTimerRef.current) {
            clearInterval(recordingTimerRef.current);
            recordingTimerRef.current = null;
        }
        setRecordingTime(0);
        setIsRecording(false);
        setMediaRecorder(null);
    }
};
   // Авто-расширение textarea
const autoResizeTextarea = () => {
  const textarea = textareaRef.current;
  if (!textarea) return;
  textarea.style.height = 'auto';
  textarea.style.height = Math.min(textarea.scrollHeight, 150) + 'px';
};
const scheduleReconnect = useCallback((minDelay = 0) => {
    if (reconnectTimerRef.current) {
        clearTimeout(reconnectTimerRef.current);
        reconnectTimerRef.current = null;
    }

    const baseDelay = reconnectAttemptsRef.current === 0
        ? 0
        : Math.min(500 * reconnectAttemptsRef.current, 5000);
    const delay = Math.max(baseDelay, minDelay);

    reconnectTimerRef.current = setTimeout(() => {
        reconnectTimerRef.current = null;

        if (!mountRef.current || !isAppActiveRef.current) {
            console.log('📱 App not active in reconnect timer, stop');
            isConnectingRef.current = false;
            setWsReconnecting(false);
            setWsError(null);
            return;
        }

        // ✅ Инкрементим до расчёта следующего delay
        reconnectAttemptsRef.current++;
        isConnectingRef.current = false;

        if (typeof connectWebSocketRef.current === 'function') {
            setWsError(null);
            connectWebSocketRef.current();
        } else {
            isConnectingRef.current = false;
        }
    }, delay);
}, []);
// doConnectWebSocket (НОВАЯ версия)
const doConnectWebSocket = useCallback(() => {
    if (!mountRef.current) return;

    const accessToken = localStorage.getItem('access_token');
    if (!accessToken) {
        isConnectingRef.current = false;
        console.warn('⏳ No token, WebSocket not connecting');
        setWsConnected(false);
        setWsReconnecting(false);
        setWsError(null);
        return;
    }

    // Если сокет уже открыт — не создаём новый
    if (wsRef.current && wsRef.current.readyState === WebSocket.OPEN) {
        setWsConnected(true);
        setWsReconnecting(false);
        setWsError(null);
        return;
    }

    // Если сокет уже в процессе подключения — не создаём второй
    if (wsRef.current && wsRef.current.readyState === WebSocket.CONNECTING) {
        console.log('⏳ Socket already connecting, skip');
        return;
    }

    // Закрываем старый сокет
    if (wsRef.current) {
        const oldWs = wsRef.current;
        wsRef.current = null; // ← СНАЧАЛА обнуляем, чтобы его onerror/onclose игнорировались
        try {
            oldWs.onopen = oldWs.onmessage = oldWs.onerror = oldWs.onclose = null;
            oldWs.close(1000, 'Reconnecting');
        } catch (e) {}
    }

    isIntentionalCloseRef.current = false;

    if (connectionTimeoutRef.current) {
        clearTimeout(connectionTimeoutRef.current);
        connectionTimeoutRef.current = null;
    }

    console.log('🔌 Connecting WebSocket...');
    const ws = new WebSocket(`${WS_URL}?token=${accessToken}`);
    wsRef.current = ws;
    isConnectingRef.current = true; // ✅ теперь честно: идёт попытка подключения

    // ✅ Таймаут подключения
    connectionTimeoutRef.current = setTimeout(() => {
        // Сокет уже неактуален — выходим
        if (ws !== wsRef.current) return;
        // Уже открылись — выходим
        if (ws.readyState === WebSocket.OPEN) return;

        console.warn('⚠️ WebSocket connection timeout');
        isConnectingRef.current = false;
        setWsReconnecting(true);
        setWsError('Долгое подключение...');

        // Пробуем закрыть зависший сокет
        try {
            ws.onopen = ws.onmessage = ws.onerror = ws.onclose = null;
            ws.close();
        } catch (e) {}
        if (wsRef.current === ws) {
            wsRef.current = null;
        }

        // Планируем реконнект через 2 сек
        scheduleReconnect(2000);
    }, 5000);

    ws.onopen = () => {
        // ✅ Проверяем, что это АКТУАЛЬНЫЙ сокет
        if (ws !== wsRef.current) {
            console.log('⚠️ Open from old socket, ignoring');
            return;
        }
        console.log('✅ WebSocket connected');
        isIntentionalCloseRef.current = false;
        clearTimeout(connectionTimeoutRef.current);
        connectionTimeoutRef.current = null;
        isConnectingRef.current = false; // ✅ Снимаем флаг
        setWsConnected(true);
        setWsReconnecting(false);
        setWsError(null);
        setWsLastCloseCode(null);
        reconnectAttemptsRef.current = 0;

        if (dataLoadedRef.current) {
            console.log('🔄 Reconnected, loading chats only...');
            if (typeof loadChatsRef.current === 'function') {
                loadChatsRef.current({ loadMessages: true });
            }
        } else {
            console.log('📦 First connect, loading all data...');
            if (typeof loadAllDataRef.current === 'function') {
                loadAllDataRef.current();
            }
        }

        if (pingIntervalRef.current) {
            clearInterval(pingIntervalRef.current);
        }
        pingIntervalRef.current = setInterval(() => {
            if (ws.readyState === WebSocket.OPEN) {
                console.log('🏓 Sending PING');
                ws.send(JSON.stringify({ type: 'ping' }));

                // ✅ Ждём pong 5 секунд
                if (pongTimeoutRef.current) {
                    clearTimeout(pongTimeoutRef.current);
                }
                pongTimeoutRef.current = setTimeout(() => {
                    console.warn('⚠️ PONG timeout, reconnecting...');
                    if (wsRef.current === ws) {
                        try {
                            ws.onopen = ws.onmessage = ws.onerror = ws.onclose = null;
                            ws.close(1000, 'Pong timeout');
                        } catch (e) {}
                        wsRef.current = null;
                        isConnectingRef.current = false;
                        setWsConnected(false);
                        setWsError('Нет Интернета!');
                        setWsReconnecting(true);
                        scheduleReconnect(0);
                    }
                }, 5000);
            }
        }, 15000);

        if (typeof sendPendingMessagesRef.current === 'function') {
            sendPendingMessagesRef.current();
        }
    };

    ws.onmessage = (event) => {
        try {
            const data = JSON.parse(event.data);           
            if (data.type === 'pong') {
                console.log('🏓 PONG received');
                if (pongTimeoutRef.current) {
                    clearTimeout(pongTimeoutRef.current);
                    pongTimeoutRef.current = null;
                }
                return;
            }

            if (data.type === 'ping') {
                console.log('🏓 PING received from server');
                return;
            }

            if (data.id && data.from_id !== userRef.current?.id) {
                // ✅ Проверяем, что сокет ещё жив
                if (ws.readyState === WebSocket.OPEN) {
                    ws.send(JSON.stringify({
                        type: 'message_received',
                        message_id: data.id,
                        chat_id: data.chat_id
                    }));
                }
            }

            if (typeof handleWebSocketMessageRef.current === 'function') {
                handleWebSocketMessageRef.current(data);
            }
        } catch (e) {
            console.error('Failed to parse WebSocket message:', e);
        }
    };

    ws.onerror = (error) => {
        if (ws !== wsRef.current) {
            console.log('⚠️ Error from old socket, ignoring');
            return;
        }
        console.error('WebSocket error:', error);
        clearTimeout(connectionTimeoutRef.current);
        connectionTimeoutRef.current = null;

        setWsError('Нет Интернета!');
        setWsReconnecting(true);

        // ✅ Если реконнект уже запланирован — не дублируем
        if (isConnectingRef.current) {
            console.log('⏳ Already connecting, skipping reconnect...');
            return;
        }
        isConnectingRef.current = true;

        scheduleReconnect(0);
    };

    ws.onclose = (event) => {
        if (ws !== wsRef.current) {
            console.log('⚠️ Close from old socket, ignoring');
            return;
        }
        if (pongTimeoutRef.current) {
            clearTimeout(pongTimeoutRef.current);
            pongTimeoutRef.current = null;
        }
        console.log(`WebSocket disconnected: ${event.code}`);

        if (pingIntervalRef.current) {
            clearInterval(pingIntervalRef.current);
            pingIntervalRef.current = null;
        }
        clearTimeout(connectionTimeoutRef.current);
        connectionTimeoutRef.current = null;

        wsRef.current = null;
        isConnectingRef.current = false;
        setWsConnected(false);
        setWsLastCloseCode(event.code);

        // ✅ Намеренное закрытие — не реконнектим
        const isIntentional = isIntentionalCloseRef.current || event.code === 1001;
        if (isIntentional) {
            console.log('🔒 Намеренное закрытие, без повторного подключения');
            setWsReconnecting(false);
            setWsError(null);
            isIntentionalCloseRef.current = false;
            return;
        }

        if (!mountRef.current || !isAppActiveRef.current) {
            console.log('📱 App not active, not reconnecting');
            setWsReconnecting(false);
            return;
        }

        setWsError('Соединение потеряно');
        setWsReconnecting(true);

        // ✅ Если onerror уже запланировал реконнект — не создаём второй таймер
        if (isConnectingRef.current) {
            console.log('⏳ Reconnect already scheduled by onerror, skip');
            return;
        }
        isConnectingRef.current = true;

        scheduleReconnect(0);
    };
}, [scheduleReconnect]);
// ✅ Функция подключения WebSocket
const connectWebSocket = useCallback(() => {
    
    // ✅ Если уже подключаемся - выходим
    if (isConnectingRef.current) { 
         console.log('⏳ Already connecting, skipping...');      
        return;
    }
    isConnectingRef.current = true;
    // ✅ 1. СНАЧАЛА ОБНОВЛЯЕМ ТОКЕН (если протух)
    const refreshToken = localStorage.getItem('refresh_token');
    const token = localStorage.getItem('access_token');
    
    // Проверяем, не протух ли токен
    let isTokenValid = false;
    if (token) {
        try {
            const payload = JSON.parse(atob(token.split('.')[1]));
            const now = Math.floor(Date.now() / 1000);
            isTokenValid = payload.exp - now > 60; // > 1 минуты
        } catch (e) {
            isTokenValid = false;
        }
    }
    // ✅ Если токен протух или его нет - обновляем через /refresh
    if (!isTokenValid && refreshToken) {
        console.log('⏳ Token expired or invalid, refreshing before WebSocket connect...');
        setWsReconnecting(true);
        setWsError('Обновление сессии...');
        
        axios.post(`${API_URL}/auth/refresh`, {
            refresh_token: refreshToken
        })
        .then(response => {
            const { access_token, refresh_token } = response.data;
            setTokens(access_token, refresh_token);
            console.log('✅ Token refreshed, connecting WebSocket...');
            
            // ✅ Теперь подключаем WebSocket с новым токеном
            doConnectWebSocket();
        })
        .catch(error => {           
            console.error('❌ Refresh failed:', error);
            isConnectingRef.current = false;
            clearTokens();
            window.location.href = '/login';
        });
        return;
    }
    doConnectWebSocket();    
}, [doConnectWebSocket]); 

const resetWsStatus = useCallback(() => {
    setWsConnected(true);
    setWsReconnecting(false);
    setWsError(null);
    setWsLastCloseCode(null);
}, []);
//Загрузка профиля пользователя
 const loadUserProfile = useCallback(async () => {
    const token = localStorage.getItem('access_token');
    if (!token || !navigator.onLine) return;
    
    try {
        const profile = await api.get('/user/profile');
        setUser(cleanUser(profile.data));
        // await loadChatsRef.current?.();
    } catch (error) {
        console.error('Load profile error:', error.message);
        throw error;   
    }
}, []);
const loadAllData = useCallback(async (options = {}) => {    
    if (dataLoadedRef.current) {
        console.log('📦 Data already loaded, skipping...');
        return;
    }    
    dataLoadedRef.current = true;
    console.log('📦 Loading all data...');
    
    try {
        // 1. Загружаем профиль 
        if (typeof loadUserProfileRef.current === 'function') {
            await loadUserProfileRef.current();
        }
        // 2. Загружаем чаты
        if (typeof loadChatsRef.current === 'function') {
            await loadChatsRef.current({ loadMessages: true });
        }      
        
        // 4. Отправляем неотправленные сообщения
        if (typeof sendPendingMessagesRef.current === 'function') {
            setTimeout(() => {
                sendPendingMessagesRef.current();
            }, 1000);
        }
        
        console.log('✅ All data loaded');
        setWsReconnecting(false);
        setWsError(null);
        
    } catch (error) {
        console.error('❌ Failed to load data:', error);
        dataLoadedRef.current = false;
        // ✅ 401 - НЕ РЕДИРЕКТИМ! Интерцептор сам обновит токен
        if (error.response?.status === 401) {
            console.warn('⏳ 401 error, interceptor will refresh token...');
            // Просто ждем, интерцептор сделает свое дело
            setWsError('Обновление сессии...');
            setWsReconnecting(true);
        } else if (error.code === 'ERR_NETWORK') {
            setWsError('Нет соединения с сервером');
            setWsReconnecting(true);
        } else {
            setWsError('Ошибка загрузки данных');
            setWsReconnecting(false);
        }
    }
}, []);
// Синхронизируем реф с актуальным состоянием при каждом изменении чата
useEffect(() => {
  currentChatRef.current = currentChat;
}, [currentChat]);
useEffect(() => {
    chatsRef.current = chats;
}, [chats]);
// ✅ Обновляем refs
useEffect(() => {
    connectWebSocketRef.current = connectWebSocket;
    loadUserProfileRef.current = loadUserProfile;
    loadChatsRef.current = loadChats;
    loadMessagesRef.current = loadMessages;
    loadAllDataRef.current = loadAllData;
    sendPendingMessagesRef.current = sendPendingMessages;
    handleWebSocketMessageRef.current = handleWebSocketMessage;
   selectChatRef.current=selectChat;
}, [connectWebSocket, loadUserProfile, loadChats, loadMessages, loadAllData, sendPendingMessages, handleWebSocketMessage, selectChat]);
useEffect(() => {
    isAppActiveRef.current = isAppActive;
}, [isAppActive]);

 
// 3.1 Обработка уведомлений когда приложение открыто
// Обновляем колбэк при каждом рендере (всегда свежий)
onFirebaseMessageHandlerRef.current = async (payload) => {
    try {
        const data = payload.data || {};
        const senderChatId = data.chat_id;
        const isActiveChat = currentChatRef.current
            && senderChatId
            && String(senderChatId) === String(currentChatRef.current.chat_id);

        console.log('📨 [Foreground] push:', {
            chatId: senderChatId,
            activeChat: currentChatRef.current?.chat_id,
            isIOS: IS_IOS,
            isStandalone: IS_STANDALONE
        });

        // ✅ Активный чат + iOS → тихое уведомление (иначе Apple отпишет)
        if (isActiveChat) {
            if (IS_IOS || IS_STANDALONE) {
                await showSystemNotification(
                    data.notification_title || 'Новое сообщение',
                    {
                        body: data.notification_body || '',
                        icon: '/logo192.png',
                        badge: '/logo192.png',
                        data: data,
                        tag: data.message_id || `msg-${Date.now()}`,
                        silent: true
                    }
                );
            }
            return;
        }

        // ✅ НЕ активный чат:        
            await showSystemNotification(
                data.notification_title || 'Новое сообщение',
                {
                    body: data.notification_body || '',
                    icon: '/logo192.png',
                    badge: '/logo192.png',
                    data: data,
                    tag: data.message_id || `msg-${Date.now()}`,
                    silent: true
                }
            );
        
        // На Android — ничего не делаем, звук уже играет handleWebSocketMessage
    } catch (e) {
        console.warn('⚠️ Не удалось показать уведомление:', e);
    }
};
useEffect(() => {
    const unsubscribe = onFirebaseMessage((payload) => {        
        Promise.resolve(onFirebaseMessageHandlerRef.current?.(payload))
            .catch(err => console.error('Handler error:', err));
    });
    return () => unsubscribe?.();      
}, []);    
// ✅ 1. Монтирование
 useEffect(() => {
    mountRef.current = true;
    isConnectingRef.current = false;
    reconnectAttemptsRef.current = 0;
    
    // Задержка перед подключением
    const timer = setTimeout(() => {
        if (typeof connectWebSocketRef.current === 'function') {
            connectWebSocketRef.current();
        }
    }, 300);

    return () => {
        mountRef.current = false;
        stopRingtone();
        isConnectingRef.current = false;
        isIntentionalCloseRef.current = true;
        
        if (reconnectTimerRef.current) {
            clearTimeout(reconnectTimerRef.current);
            reconnectTimerRef.current = null;
        }
        
        if (wsRef.current) {
            try {
                wsRef.current.close(1000, 'Cleanup');
            } catch (e) {}
            wsRef.current = null;
        }
        if (markReadTimerRef.current) {
            clearTimeout(markReadTimerRef.current);
            markReadTimerRef.current = null;
        }
        
        clearTimeout(timer);
    };
}, []);
// ✅ Инициализация SW registration при монтировании
useEffect(() => {
    if (!('serviceWorker' in navigator)) return;
    const registerSW = async () => {
        try {
            // Регистрируем именно наш SW с scope '/'
            const registration = await navigator.serviceWorker.register(
                '/firebase-messaging-sw.js',
                { scope: '/' }
            );
            console.log('✅ SW зарегистрирован:', registration.scope);
            swRegistrationRef.current = registration;
        } catch (error) {
            console.error('❌ SW registration failed:', error);
        }
    };

    registerSW();
}, []);
// ✅ ПРОВЕРКА СОСТОЯНИЯ ПРИ АКТИВАЦИИ
useEffect(() => {
    const handleVisibilityChange = () => {
         const isActive = document.visibilityState === 'visible';
            setIsAppActive(isActive);
        if (isActive) {
            console.log('📱 App became visible, checking WebSocket...');
            // ✅ Если это первая загрузка — пропускаем (подключение сделает useEffect монтирования)
            if (isFirstLoadRef.current) {
                console.log('⏳ First load, skipping visibility reconnect...');
                isFirstLoadRef.current = false;
                return;
            }
            
            // ✅ Всегда проверяем и переподключаем если нужно
            const isConnected = wsRef.current && wsRef.current.readyState === WebSocket.OPEN;
            
            if (!isConnected) {
                console.log('🔌 WebSocket not connected, reconnecting...');
                setWsReconnecting(true);
                setWsError('Cоединение visible...'); 
                     // ✅ Теперь вызываем connectWebSocket напрямую через ref!
                    if (typeof connectWebSocketRef.current === 'function') {  
                        setWsError(null);                      
                        connectWebSocketRef.current();                        
                    }                 
                
            } else {
                console.log('✅ WebSocket already connected');
                setWsReconnecting(false);
                setWsError(null);
                setWsConnected(true);   
            }      
        }
    };
 // ✅ pageshow — страница восстанавливается из bfcache (важно для iOS Safari)
    const handlePageShow = (event) => {
        if (event.persisted) {
            console.log('📱 Страница восстановлена ​​из bfcache, проверка WebSocket...');
            setIsAppActive(true);
            isFirstLoadRef.current = false;
            const isConnected =  wsRef.current.readyState === WebSocket.OPEN;
            
            if (!isConnected) {
                console.log('🔌 WebSocket not connected after bfcache, reconnecting...');
                setWsReconnecting(true);
                setWsError('Соединение cashe...');
                
               
                if (typeof connectWebSocketRef.current === 'function') {   
                    setWsError(null);                 
                    connectWebSocketRef.current();                                           
                }
            } else {
                console.log('✅ WebSocket still connected after bfcache');
                setWsReconnecting(false);
                setWsError(null); 
                setWsConnected(true);  
            }
        }
    };
// ✅ Отслеживаем, когда приложение уходит в фон
    const handlePageHide = () => {
        console.log('📱 Переход приложения в фоновый режим');
        setIsAppActive(false);
        // Не закрываем сокет, просто помечаем
    };
    const handleBeforeUnload = () => {
        console.log('📱 Страница закрывается или перезагружается');
        setIsAppActive(false);
        // ✅ Сохраняем черновики
        //saveDraftsToLocalStorage();
    };
    document.addEventListener('visibilitychange', handleVisibilityChange);
    window.addEventListener('pagehide', handlePageHide);
    window.addEventListener('beforeunload', handleBeforeUnload);
    window.addEventListener('pageshow', handlePageShow);        
    return () => {
            document.removeEventListener('visibilitychange', handleVisibilityChange);
            window.removeEventListener('pagehide', handlePageHide);
            window.removeEventListener('beforeunload', handleBeforeUnload);
            window.removeEventListener('pageshow', handlePageShow);
    };
 
}, []);
// Слушаем обновление токена
useEffect(() => {
    const handleTokenUpdated = () => {
       console.log('🔄 Token updated, reconnecting WebSocket...');
        if (typeof connectWebSocketRef.current === 'function') {
            connectWebSocketRef.current();
        }
    };
    
    window.addEventListener('tokenUpdated', handleTokenUpdated);
    return () => {
        window.removeEventListener('tokenUpdated', handleTokenUpdated);
    };
}, []);
// ✅ Единый механизм регистрации/обновления Firebase токена
useEffect(() => {    
    if (!user) return;
    if (!notificationsEnabled) {
        console.log('⏸️ Notifications disabled, skip token registration');
        return;
    }

    let isMounted = true;

    const registerOrRefreshToken = async (reason = 'unknown') => {
        try {
            const firebaseToken = await requestFirebaseToken();
            if (!firebaseToken) return;
            if (!isMounted) return;

            await api.post('/push/register', { token: firebaseToken });            
            localStorage.setItem('firebase_user_id', String(userRef.current?.id));
            localStorage.setItem('firebase_token_registered_at', new Date().toISOString());
            
            console.log(`✅ [${reason}] Token registered`);
        } catch (error) {
            console.error(`❌ [${reason}] Register failed:`, error);
        }
    };

    const timer = setTimeout(() => {
        registerOrRefreshToken('initial');
    }, 100);

    // 2️⃣ При возврате в приложение — с троттлингом
    const handleVisibilityChange = () => {
        if (document.visibilityState !== 'visible') return;
        
        const lastRegistered = localStorage.getItem('firebase_token_registered_at');
        if (lastRegistered) {
            const elapsed = Date.now() - new Date(lastRegistered).getTime();
            if (elapsed < 12 * 60 * 60 * 1000) return; // < 12ч — пропускаем
        }
        
        registerOrRefreshToken('visibility');
    };
    document.addEventListener('visibilitychange', handleVisibilityChange);

    return () => {
        isMounted = false;
        clearTimeout(timer);
        document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
     // eslint-disable-next-line react-hooks/exhaustive-deps
}, [user?.id, notificationsEnabled]); 
// ✅ Синхронизация notificationPermission при возврате вкладки
useEffect(() => {
    const syncPermission = () => {
        if (typeof Notification === 'undefined') return;
        
        const current = Notification.permission;
        setNotificationPermission(prev => {
            if (prev !== current) {
                console.log(`🔄 Permission changed: ${prev} → ${current}`);
                return current;
            }
            return prev;
        });
    };

    // При монтировании
    syncPermission();

    // При возврате вкладки
    const handleVisibility = () => {
        if (document.visibilityState === 'visible') {
            syncPermission();
        }
    };
    document.addEventListener('visibilitychange', handleVisibility);

    return () => {
        document.removeEventListener('visibilitychange', handleVisibility);
    };
}, []);
// ✅ Реагируем на клик по push-уведомлению (переход в чат)
useEffect(() => {
    if (!('serviceWorker' in navigator)) return;
    
    const handleSWMessage = (event) => {
        const { type, chatId } = event.data || {};
        
        if (type === 'OPEN_CHAT' && chatId) {
            console.log('🔔 Переход в чат из уведомления:', chatId);
            
            // Находим чат в списке и открываем его
            // Используем ref, т.к. замыкание видит старое состояние
            const chat = chatsRef.current.find(c => String(c.chat_id) === String(chatId));
            if (chat) {
                selectChatRef.current?.(chat);
            } else {
                // Чат не найден — перезагружаем список и пробуем снова
                loadChatsRef.current.then((freshChats) => {
                    const found = freshChats?.find(c => String(c.chat_id) === String(chatId));
                    if (found) selectChatRef.current?.(found);
                });
            }
        }
    };
    
    navigator.serviceWorker.addEventListener('message', handleSWMessage);
    return () => {
        navigator.serviceWorker.removeEventListener('message', handleSWMessage);
    };
}, []);
  // Debounce для поиска
  useEffect(() => {
    const timer = setTimeout(() => {
      if (searchQuery) {
        searchUsers(searchQuery);
      }
    }, 500);
    return () => clearTimeout(timer);
  }, [searchQuery, token, searchUsers]);  
  
  useEffect(() => {
    if (!messages || messages.length === 0) return;
    if (skipAutoScroll.current) {
        skipAutoScroll.current = false;
        return;
    }

    // Прокрутка после отрисовки DOM
    const raf = requestAnimationFrame(() => {
        scrollToBottom();
    });

    // Дополнительная прокрутка после подгрузки вложений/превью
    const timer = setTimeout(() => {
        scrollToBottom();
    }, 150);

    return () => {
        cancelAnimationFrame(raf);
        clearTimeout(timer);
    };
}, [messages]);
  // ✅ 4. Восстановление интернета
  useEffect(() => {
    const handleOnline = () => {
        console.log('🌐 Internet connection restored');
        isConnectingRef.current = false; // ← Сбрасываем!
        reconnectAttemptsRef.current = 0; // ← Сбрасываем!
        if (typeof connectWebSocketRef.current === 'function') {
            setWsError(null); 
            connectWebSocketRef.current();
        }
    };
    
    window.addEventListener('online', handleOnline);
    return () => window.removeEventListener('online', handleOnline);
}, []); 

useEffect(() => {
    if (!currentChat) return;
    
    const observer = new IntersectionObserver((entries) => {
        const visibleIds = entries
            .filter(entry => entry.isIntersecting)
            .map(entry => {
                const id = parseInt(entry.target.id.replace('message-', ''));
                // ✅ Находим сообщение и проверяем, входящее ли оно
                const msg = messages.find(m => m.id === id);
                if (!msg || msg.is_outgoing) return null;
                return id;
            })
            .filter(id => id !== null && !isNaN(id));
        
        if (visibleIds.length === 0) return;
        
        const maxVisibleId = Math.max(...visibleIds);
        
        // ✅ Дебаунс
        if (markReadTimerRef.current) {
            clearTimeout(markReadTimerRef.current);
        }
        markReadTimerRef.current = setTimeout(() => {
            if (currentChatIdRef.current === currentChat.chat_id) {
                markAsRead(currentChat.chat_id, maxVisibleId);
            }
        }, 500);
    }, { 
        threshold: 0.5,
        root: messagesContainerRef.current
    });
    
    document.querySelectorAll('.message').forEach(msg => observer.observe(msg));
    
    return () => {
        observer.disconnect();
        if (markReadTimerRef.current) {
            clearTimeout(markReadTimerRef.current);
            markReadTimerRef.current = null;
        }
    };
}, [messages, currentChat, markAsRead]);

  useEffect(() => {
        return () => {
            if (recordingTimerRef.current) {
                clearInterval(recordingTimerRef.current);
            }
            if (mediaRecorder && isRecording) {
                mediaRecorder.stop();
            }
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    useEffect(() => {
        // Создаём звук через Web Audio API (для коротких звуков)
       const AudioCtx = window.AudioContext || window.webkitAudioContext;
    audioContext.current = new AudioCtx();
    
    // Разблокировка при первом клике/тапе
    const unlock = () => {
        if (audioContext.current?.state === 'suspended') {
            audioContext.current.resume();
        }
        document.removeEventListener('click', unlock);
        document.removeEventListener('touchstart', unlock);
    };
    
    document.addEventListener('click', unlock, { once: true });
    document.addEventListener('touchstart', unlock, { once: true });
    
    return () => {
        document.removeEventListener('click', unlock);
        document.removeEventListener('touchstart', unlock);
    };
    }, []);
// ✅ Следим за подключением WebSocket и обновляем данные
useEffect(() => {
    if (wsConnected && currentChat) {
        console.log('🔄 WebSocket connected, loading messages for current chat');
        loadMessages(currentChat.chat_id);
    }
     // eslint-disable-next-line react-hooks/exhaustive-deps
}, [wsConnected]); 
// ✅ Реагируем на подключение
useEffect(() => {
    if (typingMessage && !showScrollButton) {
        // ✅ Скроллим вниз, чтобы показать индикатор
        setTimeout(scrollToBottom, 50);
    }
}, [typingMessage, showScrollButton]);
// обновляем статусы
useEffect(() => {
    if (!currentChat) return;    
    const updatedChat = chats.find(c => c.chat_id === currentChat.chat_id);
    if (updatedChat) {
        // ✅ Обновляем только нужные поля
        setCurrentChat(prev => {
            if (!prev) return prev;
            if (prev.is_online === updatedChat.is_online &&
                prev.last_seen === updatedChat.last_seen &&
                prev.title === updatedChat.title &&
                prev.avatar === updatedChat.avatar) {
                return prev; // ← не обновляем, если ничего не изменилось
            }
            return { ...prev, ...updatedChat };
        });
    }
}, [chats, currentChat]);
//Закрытие списка участников группы при клике вне
useEffect(() => {
    const handleClickOutside = (e) => {
        if (showMembersList && !e.target.closest('.members-dropdown') && !e.target.closest('.members-toggle')) {
            setShowMembersList(false);
        }
    };
    
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
}, [showMembersList]);
// ✅ Синхронизация разрешения при открытии модалки профиля
useEffect(() => {
    if (showProfileModal) {
        const realPermission = typeof Notification !== 'undefined' ? Notification.permission : 'default';
        console.log('🔄 Sync permission:', realPermission);
        setNotificationPermission(realPermission);

        // Если браузер запретил, а у нас включено — принудительно выключаем
        if (realPermission === 'denied' && notificationsEnabled) {
            setNotificationsEnabled(false);
            localStorage.setItem('notifications_enabled', 'false');
            api.post('/push/unregister').catch(() => {});
        }
    }
}, [showProfileModal, notificationsEnabled]);
 // Сброс зума при закрытии галереи
  
  if (!token) {
    return <Auth onAuthSuccess={handleAuthSuccess} />;
  }         
  return (    
    <div className="app">
        <ConnectionStatus />
        <WebSocketStatus 
                connected={wsConnected}
                reconnecting={wsReconnecting}
                error={wsError}
                 lastCloseCode={wsLastCloseCode}
                 isAppActive={isAppActive}
            />        
      <div className="main-container">
        <div className={`sidebar ${mobileMenuOpen ? 'open' : ''}`}>
          <div className="user-info">
            <div className="user-name" onClick={handleUserContextMenu}>
              {user?.displayName || user?.username}
            </div>
            <div className="user-actions">
              <button className="new-chat-btn" onClick={() => setShowNewChat(true)} title="Новый чат">
                <i className="bi-plus-lg"></i>
              </button>
              
            </div>
          </div>         
         <ChatList
                chats={chats}
                isLoading={isLoading}
                currentChat={currentChat}                
                onSelectChat={(chat) => {
                    selectChat(chat);
                    closeMobileMenu();
                }}
                onContextMenu={handleChatContextMenu}
                onTouchStart={(e, chat) => {
                    const touch = e.touches[0];
                    const timer = setTimeout(() => {
                        handleChatContextMenu(
                            {
                                preventDefault: () => {},
                                clientX: touch.clientX,
                                clientY: touch.clientY,
                            },
                            chat
                        );
                    }, 600);
                    e.currentTarget.addEventListener('touchend', () => clearTimeout(timer), { once: true });
                    e.currentTarget.addEventListener('touchmove', () => clearTimeout(timer), { once: true });
                }}
            />
        </div>
        {mobileMenuOpen && (
            <div className="mobile-overlay" onClick={closeMobileMenu}></div>
        )}        
        <div  className={`chat-area ${isDragging ? 'drag-over' : ''}`}
              onDragOver={handleDragOver}
              onDragLeave={handleDragLeave}
              onDrop={handleDrop}
          >
          {currentChat ? (
            <>             
            <ChatHeader
                currentChat={currentChat}
                user={user}
                token={token}
                api={api}
                isConnecting={false}
                inCall={!!activeCall}
                onStartCall={handleStartCall}
                onToggleMobileMenu={toggleMobileMenu}
                onOpenEditGroup={(chat) => {
                    setEditingGroup(chat);
                    setShowEditGroupModal(true);
                }}
                onOpenInvite={(chat) => {
                    setInviteGroup(chat);
                    setShowInviteModal(true);
                }}
            />           
                <AudioPlayerProvider>
              <div className="messages-container"
                onScroll={handleScroll}
                ref={messagesContainerRef}
              >
                 {isLoadingMore && <div className="loading-more">Загрузка старых сообщений...</div>}
                {loading && 
                
                <div  className="message-loading-center">
                    <div className="spinner"></div>
                    <p>Загрузка...</p>
                    </div>
                }
                {messages && messages.length > 0 ? (
                  messages.map((msg, idx) => (
                    <React.Fragment key={msg.id}>
                      {idx === firstUnreadIndex && (
                          <div className="new-messages-separator">
                              <span>Новые сообщения</span>
                          </div>
                      )}
                      {renderDateSeparator(msg.created_at, idx, messages)}
                     
                      <Message
                        msg={msg}
                        user={user}
                        currentChat={currentChat}
                        onContextMenu={handleMessageContextMenu}
                        onGoToOriginal={goToOriginalMessage}
                        onReplyClick={scrollToMessage}
                        onOpenGallery={openGallery}
                        onDownloadFile={downloadFile}
                        onPlayStateChange={handlePlayStateChange}
                    />
                    </React.Fragment>
                  ))
                ) : (
                  !loading && <div className="no-messages">Нет сообщений. Напишите первое!</div>
                )}
                {/* ✅ Индикатор "печатает" как входящее сообщение */}
                {typingMessage && typingMessage.chat_id === currentChat?.chat_id && (
                    <div className="message incoming typing-indicator">
                        <div className="message-content">
                         {currentChat?.type === 'group' && (
                    <div className="message-author" style={{ color: getUserColor(typingMessage.user_id) }}>
                        {typingMessage.display_name || 'Пользователь'}
                    </div>
                )}
                            <div className="typing-dots-wrapper">
                                <span className="typing-dots">
                                    <span></span>
                                    <span></span>
                                    <span></span>
                                </span>
                                <span className="typing-label">печатает</span>
                            </div>
                        </div>
                       
                    </div>
                )}
                    <div ref={messagesEndRef} />
              </div>
              </AudioPlayerProvider>
            {showScrollButton && (
                  <button 
                      className="scroll-down-btn"
                      onClick={scrollToBottom}
                      title="К последнему сообщению"
                  >
                      <i className="bi-arrow-down-circle-fill"></i>
                  </button>
              )}
            {replyTo && replyToMessage && (                
                  <ReplyIndicator
                      replyToMessage={replyToMessage}
                      onCancel={() => {
                          setReplyTo(null);
                          setReplyToMessage(null);
                      }}
                  />
              )}
              {/*Редактирование сообщения*/}
            {editingMessage && (
                    <EditIndicator
                        editingMessage={editingMessage}
                        onCancel={() => {
                            setEditingMessage(null);
                            setInputMessage('');
                            setAttachments([]);
                        }}
                    />
            )}
                {/* Превью вложений */}
            {attachments.length > 0 && (
                <AttachmentsPreview
                attachments={attachments}
                onRemove={removeAttachment}
            />
            )}
            {isUploading && (
                <UploadProgress
                    progress={uploadProgress}
                    isUploading={isUploading}
                />
            )}
            <MessageInput
                inputMessage={inputMessage}
                attachments={attachments}
                editingMessage={editingMessage}
                replyTo={replyTo}
                isRecording={isRecording}
                isUploading={isUploading}
                recordingTime={recordingTime}
                showStickerPicker={showStickerPicker}

                onInputChange={setInputMessage}
                onSendOrEdit={sendOrEditMessage}
                onFileSelect={handleFileSelect}
                onPaste={handlePaste}
                onToggleStickerPicker={() => setShowStickerPicker(!showStickerPicker)}
                onCloseStickerPicker={() => setShowStickerPicker(false)}
                onStickerSelect={handleStickerSelect}
                onStartRecording={startRecording}
                onStopRecording={stopRecording}
                onCancelRecording={cancelRecording}
                onTyping={handleTyping}
                onAutoResize={autoResizeTextarea}

                textareaRef={textareaRef}
                formatDuration={formatDuration}
            />
            </>
          ) : (
            <div className="no-chat-selected">Выберите чат</div>
          )}
           
        </div>
        
        {/* Видеозвонок */}
        

        {/* Аудиозвонок (минимальный UI) */}
        
        
      </div>
      
    {showNewChat && (
      <div className="modal-overlay">
        <div className="modal" onClick={(e) => e.stopPropagation()}>
          <div className="modal-header">
            <h3>Новый чат</h3>
            <button className="modal-close" onClick={() => setShowNewChat(false)}>✖</button>
          </div>
          <div className="modal-body">
            <input className="profile-input"
              type="text"
              placeholder="Поиск по имени, телефону, email..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              autoFocus
            />
            {searching && <div className="searching">Поиск...</div>}
            <div className="search-results">
              {searchResults && searchResults.length > 0 ? (
                searchResults.map(user => (
                  <div key={user.id} className="search-result-item" onClick={() => createPrivateChat(user)}>
                    <div className="result-name">{user.display_name}</div>
                    <div className="result-details">
                      {user.username && <span>@{user.username}</span>}
                      {user.phone && <span>{user.phone}</span>}
                    </div>
                  </div>
                ))
              ) : (
                searchQuery && !searching && <div className="no-results">Пользователи не найдены</div>
              )}
            </div>
          </div>
        </div>
      </div>
    )}
{contextMenu && (
    <ContextMenu
    x={contextMenu.x}
    y={contextMenu.y}
    items={contextMenu.items}
    onClose={() => setContextMenu(null)}
    />
)}
{contextMenuModal && (
<ContextMenuModal
    x={contextMenuModal.x}
    y={contextMenuModal.y}
    items={contextMenuModal.items}
    message={contextMenuModal.message}
    onClose={() => setContextMenuModal(null)}
/>
)}  
<ConfirmModal
    isOpen={showDeleteConfirm}
    onClose={cancelDelete}
    onConfirm={confirmDelete}
    title="Подтверждение удаления"
    message="Вы уверены, что хотите удалить это сообщение?"
    warning={messageToDelete?.is_outgoing ? 'Сообщение будет удалено для всех участников чата.' : null}
    danger={true}
    confirmText="Удалить"
/>
<ProfileModal
    isOpen={showProfileModal}
    onClose={() => setShowProfileModal(false)}
    user={user}
   
    api={api}
    clearFileCache={clearFileCache}
    onUserUpdate={setUser}
    loadChats={loadChats}
    showNotification={showNotification}
>
    {/* Блок уведомлений оставляем прямо здесь */}
    <div className="notification-settings">
        <div className="profile-field">
            <label>Уведомления</label>
            <div className="notification-control">
                {IS_IOS_WITHOUT_PWA && (
                    <div className="ios-pwa-hint">
                       <div className="ios-pwa-hint-title">
                            <i className="bi bi-info-circle-fill"></i> Установите приложение
                        </div>
                        <p className="ios-pwa-hint-text">
                            Чтобы получать уведомления на iPhone, добавьте MesDs на экран «Домой»:
                        </p>
                        <ol className="ios-pwa-hint-steps">
                            <li>
                                Нажмите <i className="bi bi-box-arrow-up"></i> <b>Поделиться</b> в Safari
                            </li>
                            <li>
                                Выберите <b>«На экран Домой»</b>
                            </li>
                            <li>
                                Откройте приложение <b>с иконки на домашнем экране</b>
                            </li>
                            <li>
                                Включите уведомления в этом же меню
                            </li>
                        </ol>
                    </div>
                )}
                {!IS_IOS_WITHOUT_PWA && !SUPPORTS_PUSH && (
                    <div className="notification-unsupported">
                        <i className="bi bi-x-circle-fill"></i>
                        <span>Уведомления не поддерживаются в этом браузере</span>
                    </div>
                )}
                {!IS_IOS_WITHOUT_PWA && SUPPORTS_PUSH && notificationPermission === 'denied' && (
                    <div className="notification-blocked">
                       <i className="bi bi-exclamation-triangle-fill"></i>
                        <div>
                            <div>Уведомления заблокированы браузером</div>
                            <div className="notification-hint">
                                Откройте 🔒 в адресной строке → Уведомления → Разрешить
                            </div>
                        </div>
                    </div>
                )}
                {!IS_IOS_WITHOUT_PWA && SUPPORTS_PUSH && notificationPermission !== 'denied' && (
    <>
        <span className="notification-status">
            {(notificationsEnabled && notificationPermission === 'granted')
                ? '✅ Включено'
                : '⏸️ Отключено'}
        </span>
        
        <button 
            className={`notification-btn ${(notificationsEnabled && notificationPermission === 'granted') ? 'active' : ''}`}
            onClick={() => {
                // Если разрешение не получено — вызываем enable (там будет запрос)
                if (notificationPermission !== 'granted') {
                    enableNotifications();
                } else {
                    // Если разрешение есть, но выключено — включаем
                    // Если включено — выключаем
                    if (notificationsEnabled) {
                        disableNotifications();
                    } else {
                        enableNotifications();
                    }
                }
            }}
        >
            {(notificationsEnabled && notificationPermission === 'granted')
                ? '🔕 Отключить'
                : '🔔 Включить'}
        </button>
    </>
)}
            </div>
        </div>
    </div>
</ProfileModal>
{showForwardModal && forwardMessage && (
    <ForwardModal
    isOpen={showForwardModal}
    onClose={() => {
        setShowForwardModal(false);
        setForwardMessage(null);
    }}
    forwardMessage={forwardMessage}
    chats={chats}
    currentChat={currentChat}    
    onSend={sendForward}
    />
)}
{/* Модальное окно галереи */}
{galleryOpen && (
    <div className="gallery-modal" onClick={() => setGalleryOpen(false)}>            
        <div className="gallery-modal-content" onClick={(e) => e.stopPropagation()}>
            <TransformWrapper 
            key={galleryIndex}
                initialScale={1}
                minScale={0.5}
                maxScale={6} // Ограничиваем максимальный зум
                centerOnInit={true}
                centerZoomedOut={true}
                pinch={0.5}
                doubleClick={{ disabled: false, step: 0.7 }}                    
                wrapperClass="gallery-transform-wrapper"                  
            >                    
                <TransformComponent 
                    wrapperClass="gallery-transform-inner"
                contentClass="gallery-transform-content"
                >
                <FileAttachment 
                mediaUrl={galleryImages[galleryIndex]?.media_url}                    
                />
                </TransformComponent>
            </TransformWrapper>           
        
        {galleryImages.length>1 && (
                    <div className="gallery-controls">
                    <button 
                    className="gallery-btn-prev"
                    onClick={() => {setGalleryIndex((galleryIndex - 1 + galleryImages.length) % galleryImages.length);}}>
                        <i className='bi bi-forward rotate-180' ></i>
                    </button>
                    <span className="gallery-counter">{galleryIndex + 1} / {galleryImages.length}</span>
                    <button 
                    className="gallery-btn-next"
                    onClick={() => {setGalleryIndex((galleryIndex + 1) % galleryImages.length); }}>
                        <i className='bi bi-forward'></i>
                    </button>
                </div>
            )}
            <button 
                className="image-download-btn"
                onClick={()=>downloadFile(galleryImages[galleryIndex])}
                title="Скачать изображение"                    
            >
                <i className="bi bi-download"></i>
            </button>
                <button className="gallery-close" onClick={() => setGalleryOpen(false)}>
                <i className='bi bi-x'></i>
            </button>
        </div>                
    </div>
)}
{/* Модальное окно создания группы */}
<CreateGroupModal
    isOpen={showCreateGroup}
    onClose={() => setShowCreateGroup(false)}      
    onCreate={handleCreateGroup}
    searchUsers={searchUsersForGroup}
    showNotification={showNotification}
/>
<EditGroupModal
    isOpen={showEditGroupModal}
    onClose={() => {
        setShowEditGroupModal(false);
        setEditingGroup(null);
    }}
    group={editingGroup}
    onSave={handleSaveGroup}
    showNotification={showNotification}
/>
<InviteModal
    isOpen={showInviteModal}
    onClose={() => {
        setShowInviteModal(false);
        setInviteGroup(null);
    }}
    group={inviteGroup}    
    api={api}
    onInvite={handleInvite}
/>
{/* Уведомление */}
<Toast
    show={notification.show}
    type={notification.type}
    message={notification.message}
    onClose={() => setNotification({ show: false, message: '', type: 'info' })}
/>
{incomingCall && (
    <div className="incoming-call-modal">
        
        <div className="incoming-call-content">
            <div className="incoming-call-avatar">
                <i className="bi-person-circle"></i>
            </div>
            <div className="incoming-call-name">{incomingCall.fromName}</div>
            <div className="incoming-call-type">
                {incomingCall.isVideo ? '📹 Видеозвонок' : '📞 Аудиозвонок'}
            </div>
            <div className="incoming-call-actions">
                <button className="accept-call-btn" onClick={acceptIncomingCall}>
                    <i className="bi-telephone-fill"></i> 
                </button>
                <button className="reject-call-btn" onClick={rejectIncomingCall}>
                    <i className="bi-telephone-x-fill"></i> 
                </button>
            </div>
        </div>
    </div>
)} 
{/* Модальное окно звонка */}
{activeCall && (
    <CallModal
        token={activeCall.token}
        serverUrl={LIVEKIT_URL}
        isVideo={activeCall.isVideo}
        chatTitle={activeCall.chatTitle}
         chatId={activeCall.chatId}
        otherUserId={getOtherUserId(activeCall.chatId)}
        onEndCall={(chatId, otherUserId) => endCall(true, chatId, otherUserId)}
        onDisconnected={() => endCall(false)}
    />
)}  
{/* Модальное окно подтверждения */}
<ConfirmModal
    isOpen={confirmModal.show}
    onClose={() => setConfirmModal({ 
        show: false, 
        title: '', 
        message: '', 
        onConfirm: null, 
        danger: false 
    })}
    onConfirm={() => {
        if (confirmModal.onConfirm) confirmModal.onConfirm();
        setConfirmModal({ 
            show: false, 
            title: '', 
            message: '', 
            onConfirm: null, 
            danger: false 
        });
    }}
    title={confirmModal.title}
    message={confirmModal.message}
    danger={confirmModal.danger}
    warning={confirmModal.danger ? 'Это действие нельзя отменить.' : null}
    confirmText="Подтвердить"
/> 

</div>
    
 );
 
}
export default App;